namespace Vit.Reports {
    export class Localization {

        static fa: string = `<?xml version="1.0" encoding="utf-8" standalone="yes"?>
<Localization language="Farsi" description="Farsi" cultureName="fa">
  <A_WebViewer>
    <FirstPage>صفحه اول</FirstPage>
    <LastPage>صفحه آخر</LastPage>
    <Loading>بارگداری...</Loading>
    <NextPage>صفحه بعد</NextPage>
    <OnePage>یک صفحه</OnePage>
    <Page>صفحه</Page>
    <PageOf>از</PageOf>
    <PreviousPage>صفحه ی قبل </PreviousPage>
    <PrintReport>چاپ گزارش</PrintReport>
    <PrintToPdf>پرینت به PDF</PrintToPdf>
    <PrintWithoutPreview>پرینت بدون پیش نمایش</PrintWithoutPreview>
    <PrintWithPreview>پرینت با پیش نمایش</PrintWithPreview>
    <SaveReport>ذخیره گزارش</SaveReport>
    <WholeReport>تمام گزارش</WholeReport>
  </A_WebViewer>
  <Adapters>
    <AdapterBusinessObjects>اطلاعات از اشیای تجاری</AdapterBusinessObjects>
    <AdapterDataTables>داده از مجموعه داده و جداول داده</AdapterDataTables>
    <AdapterDataViews>داده از  جدولهای نمایش داده</AdapterDataViews>
    <AdapterDB2Connection>داده از ارتباط پایگاه داده 2 IBM</AdapterDB2Connection>
    <AdapterDBaseFiles>داده از پرونده های پایگاه داده</AdapterDBaseFiles>
    <AdapterFirebirdConnection>داده از منابع قابل شمارش</AdapterFirebirdConnection>
    <AdapterMySQLConnection> MySQL داده از ارتباط</AdapterMySQLConnection>
    <AdapterOdbcConnection>ODBC   داده از ارتباط </AdapterOdbcConnection>
    <AdapterOleDbConnection> OLE DB  داده از ارتباط</AdapterOleDbConnection>
    <AdapterOracleConnection>Oracle  داده از ارتباط</AdapterOracleConnection>
    <AdapterPostgreSQLConnection>PostgreSQL داده از ارتباط</AdapterPostgreSQLConnection>
    <AdapterSqlCeConnection> SQL CE داده از ارتباط</AdapterSqlCeConnection>
    <AdapterSqlConnection>Sql داده از ارتباط</AdapterSqlConnection>
    <AdapterUserSources>داده از منابع کاربر</AdapterUserSources>
    <AdapterVirtualSource>داده از سایر منابع داده</AdapterVirtualSource>
    <AdapterVistaDBConnection> VistaDB داده از ارتباط</AdapterVistaDBConnection>
  </Adapters>
  <Buttons>
    <Add>جمع</Add>
    <AddAllColumns>جمع همه ستون ها </AddAllColumns>
    <Build>ساختن</Build>
    <Cancel>&amp;انصراف</Cancel>
    <Close>بستن</Close>
    <Delete>حذف</Delete>
    <Design>طراحی</Design>
    <Down>پایین</Down>
    <Export>صادر کردن</Export>
    <Help>کمک</Help>
    <Ok>&amp;تایید</Ok>
    <Open>باز کردن</Open>
    <Print>چاپ</Print>
    <Remove>از بین بردن</Remove>
    <Rename>تغییر نام</Rename>
    <RestoreDefaults>بازگشت به حالت اولیه</RestoreDefaults>
    <Save>ذخیره</Save>
    <Test>آزمایش</Test>
    <Up>بالا</Up>
  </Buttons>
  <Chart>
    <AddCondition>اضافه کردن ارتباط</AddCondition>
    <AddConstantLine>اضافه کردن خط ثابت</AddConstantLine>
    <AddFilter>&amp;اضافه کردن فیلتر</AddFilter>
    <AddSeries>اضافه کرن سری ها</AddSeries>
    <AddStrip>اضافه کردن نوار</AddStrip>
    <Area>محیط</Area>
    <Axes>محورها</Axes>
    <AxisReverse>برعکس</AxisReverse>
    <AxisX> Xمحور </AxisX>
    <AxisY> Yمحور </AxisY>
    <ChartConditionsCollectionForm>شرایط</ChartConditionsCollectionForm>
    <ChartFiltersCollectionForm>فیلترها</ChartFiltersCollectionForm>
    <ChartType>نوع نمودار</ChartType>
    <CheckBoxAutoRotation>چرخش خودکار</CheckBoxAutoRotation>
    <ClusteredBar>میله دسته ای</ClusteredBar>
    <ClusteredColumn>ستون دسته ای</ClusteredColumn>
    <ConstantLine>خط ثابت</ConstantLine>
    <ConstantLinesEditorForm>ویرایشگر خط ثابت</ConstantLinesEditorForm>
    <DataColumns>ستون های داده</DataColumns>
    <Doughnut>حلقه ای</Doughnut>
    <FullStackedArea>محیط کامل پشته ای</FullStackedArea>
    <FullStackedBar>میله کامل پشته ای </FullStackedBar>
    <FullStackedColumn>کامل پشته ای ستون</FullStackedColumn>
    <FullStackedLine>خط کامل پشته ای</FullStackedLine>
    <FullStackedSpline>چند قطعه ای کامل پشته ای</FullStackedSpline>
    <FullStackedSplineArea>محیط چنئ قطعه ای</FullStackedSplineArea>
    <Gantt>Gantt</Gantt>
    <GridInterlaced>درهم آمیختن</GridInterlaced>
    <GridLines>خط های شبکه ای</GridLines>
    <LabelAlignment>تنظیم</LabelAlignment>
    <LabelAlignmentHorizontal>:افقی</LabelAlignmentHorizontal>
    <LabelAlignmentVertical>:عمودی</LabelAlignmentVertical>
    <LabelAngle>:زاویه</LabelAngle>
    <LabelArgumentDataColumn>:آرگومان ستون داده</LabelArgumentDataColumn>
    <LabelAutoRotation>:چرخش اتوماتیک</LabelAutoRotation>
    <LabelHorizontal>:افقی</LabelHorizontal>
    <LabelMinorCount>:شمارش کوچک</LabelMinorCount>
    <Labels>برچسب ها</Labels>
    <LabelsCenter>مرکز</LabelsCenter>
    <LabelSeriesName>:نام سری ها</LabelSeriesName>
    <LabelsInside>داخل</LabelsInside>
    <LabelsInsideBase>پایگاه داخل</LabelsInsideBase>
    <LabelsInsideEnd>انتهای داخل</LabelsInsideEnd>
    <LabelsNone>هیچ</LabelsNone>
    <LabelsOutside>بیرون</LabelsOutside>
    <LabelsOutsideBase>پایگاه بیرون</LabelsOutsideBase>
    <LabelsOutsideEnd>انتهای بیرون</LabelsOutsideEnd>
    <LabelsTwoColumns>دو ستون</LabelsTwoColumns>
    <LabelTextAfter>:متن بعدی</LabelTextAfter>
    <LabelTextBefore>:متن قبلی</LabelTextBefore>
    <LabelTitleAlignment>:تنظیم</LabelTitleAlignment>
    <LabelValueDataColumn>:مقدار ستون داده</LabelValueDataColumn>
    <LabelValueType>:نوع مقدار</LabelValueType>
    <LabelVertical>:عمودی</LabelVertical>
    <LabelVisible>:قابل رویت</LabelVisible>
    <Legend>فهرست علایم</Legend>
    <LegendSpacing>فاصله گداری</LegendSpacing>
    <Line>خط</Line>
    <ListOfValues>لیست ستون ها</ListOfValues>
    <Marker>نشانه گذار</Marker>
    <MoveConstantLineDown>حرکت خط ثابت به پایین</MoveConstantLineDown>
    <MoveConstantLineUp>حرکت خط ثابت به بالا</MoveConstantLineUp>
    <MoveSeriesDown>حرکت سری ها به داخل</MoveSeriesDown>
    <MoveSeriesUp>حرکت سری ها به بالا</MoveSeriesUp>
    <MoveStripDown>حرکت نوار به پایین</MoveStripDown>
    <MoveStripUp>حرکت  نوار به بالا</MoveStripUp>
    <NoConditions>بدون شرط</NoConditions>
    <NoFilters>بدون فیلتر</NoFilters>
    <Pie>دایره ای</Pie>
    <RemoveCondition>&amp;پاک کردن شرط</RemoveCondition>
    <RemoveConstantLine>پاک کردن خط ثابت</RemoveConstantLine>
    <RemoveFilter>&amp;اک کردن فیلتر</RemoveFilter>
    <RemoveSeries>حذف سری ها</RemoveSeries>
    <RemoveStrip>اک کردن نوار</RemoveStrip>
    <RunChartWizard>اجرای جادوی جدول</RunChartWizard>
    <Scatter>جدا کردن</Scatter>
    <ScatterLine>خط جدا کننده</ScatterLine>
    <ScatterSpline>نوار جداکننده</ScatterSpline>
    <Series>سری ها</Series>
    <SeriesColorsCollectionForm>رنگ های سری</SeriesColorsCollectionForm>
    <SeriesEditorForm>ویرایشگر سری ها</SeriesEditorForm>
    <Serieses>سری ها</Serieses>
    <Spline>چند قطعه ای</Spline>
    <SplineArea>محیط چند قطعه ای</SplineArea>
    <StackedArea>محیط پشته ای</StackedArea>
    <StackedBar>میله پشته ای</StackedBar>
    <StackedColumn>ستون پشته ای</StackedColumn>
    <StackedLine>خط پشته ای</StackedLine>
    <StackedSpline>چند قطعه ای پشته ای</StackedSpline>
    <StackedSplineArea>محیط چند قطعه ای پشته ای</StackedSplineArea>
    <SteppedArea>محیط پله ای</SteppedArea>
    <SteppedLine>خط پله ای</SteppedLine>
    <Strip>نوار</Strip>
    <StripsEditorForm>فرم ویرایش نوارها</StripsEditorForm>
    <Style>سبک</Style>
  </Chart>
  <Components>
    <StiBarCode>رمز میله ای</StiBarCode>
    <StiChart>نمودار</StiChart>
    <StiCheckBox>جعبه چک</StiCheckBox>
    <StiChildBand>فرزند</StiChildBand>
    <StiClone>تکثیر</StiClone>
    <StiColumnFooterBand>ستون زیرنویس</StiColumnFooterBand>
    <StiColumnHeaderBand>ستون سرصفحه</StiColumnHeaderBand>
    <StiComponent>مولفه</StiComponent>
    <StiContainer>حامل</StiContainer>
    <StiContourText>نوشته ناحیه</StiContourText>
    <StiCrossColumn>ستون متقاطع</StiCrossColumn>
    <StiCrossColumnTotal>جمع ستون متقاطع</StiCrossColumnTotal>
    <StiCrossDataBand>داده متقاطع</StiCrossDataBand>
    <StiCrossFooterBand>زیرنویس متقاطع</StiCrossFooterBand>
    <StiCrossGroupFooterBand>زیرنویس گروهی متقاطع</StiCrossGroupFooterBand>
    <StiCrossGroupHeaderBand>سرصفحه گروهی متقاطع</StiCrossGroupHeaderBand>
    <StiCrossHeaderBand>سرصفحه متقاطع</StiCrossHeaderBand>
    <StiCrossRow>ردیف متقاطع</StiCrossRow>
    <StiCrossRowTotal>جمع ردیف متقاطع</StiCrossRowTotal>
    <StiCrossSummary>خلاصه پیوند</StiCrossSummary>
    <StiCrossTab>جدول بندی پیوند</StiCrossTab>
    <StiDataBand>داده</StiDataBand>
    <StiEmptyBand>نوار خالی</StiEmptyBand>
    <StiFooterBand>زیرنویس</StiFooterBand>
    <StiGroupFooterBand>گروه زیرنویس</StiGroupFooterBand>
    <StiGroupHeaderBand>گروه سرصفحه</StiGroupHeaderBand>
    <StiHeaderBand>سرصفحه</StiHeaderBand>
    <StiHierarchicalBand>باند سلسله مراتبی</StiHierarchicalBand>
    <StiHorizontalLinePrimitive>خط افقی</StiHorizontalLinePrimitive>
    <StiImage>تصویر</StiImage>
    <StiOverlayBand>روی هم قرار دادن</StiOverlayBand>
    <StiPage>صفحه</StiPage>
    <StiPageFooterBand>زیرنویس صفحه</StiPageFooterBand>
    <StiPageHeaderBand>سرصفحه صفحه</StiPageHeaderBand>
    <StiRectanglePrimitive>مستطیل</StiRectanglePrimitive>
    <StiReport>گزارش</StiReport>
    <StiReportSummaryBand>خلاصه گزارش</StiReportSummaryBand>
    <StiReportTitleBand>عنوان گزارش</StiReportTitleBand>
    <StiRichText>متن توانا</StiRichText>
    <StiShape>شکل</StiShape>
    <StiSubReport>زیر)جزء( گزارش</StiSubReport>
    <StiSystemText>متن سیستم</StiSystemText>
    <StiTable>جودل</StiTable>
    <StiText>متن</StiText>
    <StiTextInCells>متن سلول ها</StiTextInCells>
    <StiVerticalLinePrimitive>خط عمودی</StiVerticalLinePrimitive>
    <StiWinControl>Win کنترل</StiWinControl>
    <StiZipCode>کد فشرده</StiZipCode>
  </Components>
  <Database>
    <Connection>ارتباط</Connection>
    <DatabaseDB2>IBM DB2 ارتباط با پایگاه داده</DatabaseDB2>
    <DatabaseFirebird>Firebird ارتباط</DatabaseFirebird>
    <DatabaseMySQL>MySQL ارتباط با پایگاه داده</DatabaseMySQL>
    <DatabaseOdbc>ODBC ارتباط</DatabaseOdbc>
    <DatabaseOleDb>OLE DB ارتباط</DatabaseOleDb>
    <DatabaseOracle>Oracle ارتباط</DatabaseOracle>
    <DatabasePostgreSQL>PostgreSQL ارتباط</DatabasePostgreSQL>
    <DatabaseSql>SQL ارتباط</DatabaseSql>
    <DatabaseSqlCe>SQLServerCE ارتباط  یا پایگاه داده</DatabaseSqlCe>
    <DatabaseVistaDB>VistaDB ارتباط یا پایگاه داده</DatabaseVistaDB>
    <DatabaseXml>XML داده</DatabaseXml>
  </Database>
  <Dialogs>
    <StiButtonControl>دکمه</StiButtonControl>
    <StiCheckBoxControl>جعبه چک</StiCheckBoxControl>
    <StiCheckedListBoxControl>جعبه چک لیست شده</StiCheckedListBoxControl>
    <StiComboBoxControl>جهبه دسته ی کوچک</StiComboBoxControl>
    <StiDateTimePickerControl>بردا رنده تاریخ ساعت</StiDateTimePickerControl>
    <StiForm>فرم</StiForm>
    <StiGridControl>دریچه</StiGridControl>
    <StiGroupBoxControl>جعبه گروه</StiGroupBoxControl>
    <StiLabelControl>برچسب</StiLabelControl>
    <StiListBoxControl>جعبه لیستی</StiListBoxControl>
    <StiListViewControl>دیدن لیست</StiListViewControl>
    <StiLookUpBoxControl>جعبه مراجعه</StiLookUpBoxControl>
    <StiNumericUpDownControl>شمارشی بالا به پایین</StiNumericUpDownControl>
    <StiPanelControl>صفحه</StiPanelControl>
    <StiPictureBoxControl>جعبه تصویر</StiPictureBoxControl>
    <StiRadioButtonControl>دکمه رادیویی</StiRadioButtonControl>
    <StiReportControl>کنترل گزارش</StiReportControl>
    <StiRichTextBoxControl>جعبه متن پویا</StiRichTextBoxControl>
    <StiTextBoxControl>جعبه متن</StiTextBoxControl>
    <StiTreeViewControl>دید درختی</StiTreeViewControl>
  </Dialogs>
  <Editor>
    <CantFind>داده ای که شما به دنبالش می گردید نمی توان پیدا کرد </CantFind>
    <CollapseToDefinitions>خراب شدن تعاریف</CollapseToDefinitions>
    <Column>ستون:{0}</Column>
    <EntireScope>&amp;کل میدان دید</EntireScope>
    <Find>&amp;پیدا کردن</Find>
    <FindNext>&amp;بعدی را پیدا کن</FindNext>
    <FindWhat>پیدا کن چه چیز را:</FindWhat>
    <FromCursor>از نشانه رو</FromCursor>
    <GotoLine> خط&amp;برو به</GotoLine>
    <Line>خط:{0}</Line>
    <LineNumber>خط شماره:</LineNumber>
    <LineNumberIndex>({0} - {1})خط شماره </LineNumberIndex>
    <MarkAll>&amp;همه را نشانه بگذار</MarkAll>
    <MatchCase>مورد &amp;تطبیق بده</MatchCase>
    <MatchWholeWord>تمام کلمه &amp;تطبیق بده</MatchWholeWord>
    <Outlining>خط کشی&amp;بیرون</Outlining>
    <PromptOnReplace>اجازه برای جایگزینی</PromptOnReplace>
    <Replace>&amp;جایگزین</Replace>
    <ReplaceAll>همه&amp;جایگزین</ReplaceAll>
    <ReplaceWith>جایگزین با:</ReplaceWith>
    <Search>جستجو</Search>
    <SearchHiddenText>متن مخفی</SearchHiddenText>
    <SearchUp>به بالا &amp;جستجو</SearchUp>
    <SelectionOnly>فقط &amp;انتخاب</SelectionOnly>
    <ShowLineNumbers>نمایش اعداد خطوط</ShowLineNumbers>
    <StopOutlining>متوقف کن&amp;خلاصه کردن</StopOutlining>
    <titleFind>پیدا کردن</titleFind>
    <titleGotoLine>برو به خط</titleGotoLine>
    <titleReplace>جایگزین</titleReplace>
    <ToggleAllOutlining>همه را به صرفصل خلاصه کن</ToggleAllOutlining>
    <ToggleOutliningExpansion>همه را با جزیاات نشان بده</ToggleOutliningExpansion>
    <UseRegularExpressions>عبارات منظم &amp;استفاده کن از</UseRegularExpressions>
  </Editor>
  <Errors>
    <ComponentIsNotRelease>مولفه تحویل داده نشد{0}.</ComponentIsNotRelease>
    <ContainerIsNotValidForComponent>حامل {0} برای مولفه {1}معتبر نیست</ContainerIsNotValidForComponent>
    <DataNotFound>داده پیدا نشد.</DataNotFound>
    <Error>اشتباه</Error>
    <FieldRequire>میدان {0} نیاز به پر کردن داشت</FieldRequire>
    <FileNotFound>پیدا نشد "{0}" فایل.</FileNotFound>
    <IdentifierIsNotValid>مشخصه {0} پیدا نشد.</IdentifierIsNotValid>
    <ImpossibleFindDataSource>پیدا کردن منبع داده امکان پذیر نیست</ImpossibleFindDataSource>
    <NameExists> .هم اکنون یک مولفه با نام'{0}'وجود دارد مولفه ها باید نام های واحد داشته باشند.و نام ها باید حساس به متن باشند</NameExists>
    <NoServices>سرویس ها در'{0}'پیدا نشد</NoServices>
    <NotAssign>منبع داده مشخص نشده است</NotAssign>
    <RelationsNotFound>ارتباطات پیدا نشد</RelationsNotFound>
    <ServiceNotFound>'{0}' سرویس پیدا نشد</ServiceNotFound>
  </Errors>
  <Export>
    <AddPageBreaks>اضافه جدا کننده صفحه</AddPageBreaks>
    <AllowCopyTextAndGraphics>اجاره کپی متن و گرافیک</AllowCopyTextAndGraphics>
    <AllowModifyContents>اجاره تصحیح محتوا</AllowModifyContents>
    <AllowPrintDocument>اجاره تصحیح سند</AllowPrintDocument>
    <Color>رنگ</Color>
    <Compressed>فشرده شده</Compressed>
    <DigitalSignature>امضای دیجیتالی</DigitalSignature>
    <DocumentSecurity>سند محرمانه</DocumentSecurity>
    <DotMatrixMode>حالت ماتریس نقطه ای</DotMatrixMode>
    <EmbeddedFonts>خانواده حروف محدود شده</EmbeddedFonts>
    <Encoding>رمزگذاری:</Encoding>
    <ExportDataOnly>فقط بیرون دادن داده</ExportDataOnly>
    <ExportEachPageToSheet>صادرکردن برگه به صفحه</ExportEachPageToSheet>
    <ExportingCalculatingCoordinates>محاسبه ی مختصات</ExportingCalculatingCoordinates>
    <ExportingCreatingDocument>خلق سند</ExportingCreatingDocument>
    <ExportingFormatingObjects>قالب بندی اشیا</ExportingFormatingObjects>
    <ExportingReport>گزارش خروجی</ExportingReport>
    <ExportMode>وضعیت بیرون برنده:</ExportMode>
    <ExportModeFrame>فریم</ExportModeFrame>
    <ExportModeTable>جدول</ExportModeTable>
    <ExportObjectFormatting>قالب بندی اشیای خروجی</ExportObjectFormatting>
    <ExportPageBreaks>شکستن برگه های خروجی</ExportPageBreaks>
    <ExportRtfTextAsImage>صادرکردن متون غنی شده به صورت تصویر</ExportRtfTextAsImage>
    <ExportTypeBmpFile>BMP تصویر</ExportTypeBmpFile>
    <ExportTypeCalcFile>بازکردن پرونده حساب کننده</ExportTypeCalcFile>
    <ExportTypeCsvFile>CSV فایل</ExportTypeCsvFile>
    <ExportTypeDbfFile> DBFفایل پایگاه داده...</ExportTypeDbfFile>
    <ExportTypeExcel2007File>Microsoft Excel 2007 فایل...</ExportTypeExcel2007File>
    <ExportTypeExcelFile>Microsoft Excel فایل</ExportTypeExcelFile>
    <ExportTypeExcelXmlFile>Microsoft Excel Xml فایل</ExportTypeExcelXmlFile>
    <ExportTypeGifFile>GIF تصویر</ExportTypeGifFile>
    <ExportTypeHtmlFile>HTML فایل</ExportTypeHtmlFile>
    <ExportTypeJpegFile>JPEG تصویر</ExportTypeJpegFile>
    <ExportTypeMetafile>Windows ابرفایل</ExportTypeMetafile>
    <ExportTypeMhtFile>MHT Web آرشیو...</ExportTypeMhtFile>
    <ExportTypePdfFile>Adobe PDF فایل</ExportTypePdfFile>
    <ExportTypePngFile>PNG تصویر</ExportTypePngFile>
    <ExportTypeRtfFile>Rich Text فایل</ExportTypeRtfFile>
    <ExportTypeTiffFile>TIFF تصویر</ExportTypeTiffFile>
    <ExportTypeTxtFile>Text فایل</ExportTypeTxtFile>
    <ExportTypeWord2007File>Microsoft Word فایل...</ExportTypeWord2007File>
    <ExportTypeWriterFile>بازکردن پرونده نویسنده</ExportTypeWriterFile>
    <ExportTypeXmlFile>XML فایل</ExportTypeXmlFile>
    <ExportTypeXpsFile>Microsoft XPS فایل...</ExportTypeXpsFile>
    <GetCertificateFromCryptoUI>گرفتن گواهینامه Crypto UI</GetCertificateFromCryptoUI>
    <ImageCutEdges>حاشیه های بریده شده</ImageCutEdges>
    <ImageFormat>قالب تصویر:</ImageFormat>
    <ImageGrayscale>برد سایه روشن</ImageGrayscale>
    <ImageMonochrome>تک رنگ</ImageMonochrome>
    <ImageQuality>کیفیت تصویر</ImageQuality>
    <ImageResolution>شفافیت تصویر:</ImageResolution>
    <ImageType>نوع تصویر</ImageType>
    <labelEncryptionKeyLength>:طول کلید رمزدار شده</labelEncryptionKeyLength>
    <labelOwnerPassword>:رمز مالک</labelOwnerPassword>
    <labelSubjectNameString>رشته نام موضوع:</labelSubjectNameString>
    <labelUserPassword>:رمز کاربر</labelUserPassword>
    <MoreSettings>تنظیمات بیشتر</MoreSettings>
    <MultipleFiles>فایل های چندتایی</MultipleFiles>
    <OpenAfterExport>باز کردن بعد از صادرکردن</OpenAfterExport>
    <Separator>جداکننده:</Separator>
    <Settings>تنظیمات</Settings>
    <SkipColumnHeaders>گذر از سر ستون</SkipColumnHeaders>
    <StandardPDFFonts>فونت های استاندارد pdf</StandardPDFFonts>
    <title>تنظیمات صادر شدن:</title>
    <TxtBorderType>نوع حاشیه:</TxtBorderType>
    <TxtBorderTypeDouble>Unicode-Double</TxtBorderTypeDouble>
    <TxtBorderTypeSimple>ساده</TxtBorderTypeSimple>
    <TxtBorderTypeSingle>Unicode-Single</TxtBorderTypeSingle>
    <TxtCutLongLines>برش خطوط بلند</TxtCutLongLines>
    <TxtDrawBorder>طراحی حاشیه</TxtDrawBorder>
    <TxtKillSpaceGraphLines>بین بردن فضای خطوط گراف </TxtKillSpaceGraphLines>
    <TxtKillSpaceLines>از بین بردن خط خالی</TxtKillSpaceLines>
    <TxtPutFeedPageCode>صفحه کد خالی بگذار</TxtPutFeedPageCode>
    <UseDigitalSignature>استفاده از امضای دیجیتالی</UseDigitalSignature>
    <UseOnePageHeaderAndFooter>استفاده از یک سربرگ و ته برگ</UseOnePageHeaderAndFooter>
    <UsePageHeadersAndFooters>استفاده از سربرگها و ته برگها</UsePageHeadersAndFooters>
    <UseUnicode>استفاده از کد جهانی</UseUnicode>
    <X>X:</X>
    <Y>Y:</Y>
    <Zoom>زوم:</Zoom>
  </Export>
  <FileFilters>
    <AllImageFiles>همه ی فایل های تصویری</AllImageFiles>
    <BitmapFiles>Bitmap فایل های</BitmapFiles>
    <BmpFiles>BMP تصویر (*.bmp)|*.bmp</BmpFiles>
    <CalcFiles>بازکردن پرونده حساب کننده (*.ods)|*.ods</CalcFiles>
    <CsvFiles>CSV فایلها (*.csv)|*.csv</CsvFiles>
    <DataSetXmlData>منبع داده XML Data (*.xml)|*.xml</DataSetXmlData>
    <DataSetXmlSchema>منبع داده XML schema (*.xsd)|*.xsd</DataSetXmlSchema>
    <DbfFiles>DBF فایل های (*.dbf)|*.dbf</DbfFiles>
    <DictionaryFiles>دیکشنری فایل ها (*.dct)|*.dct</DictionaryFiles>
    <DllFiles>DLL فایل های (*.dll)|*.dll</DllFiles>
    <DocumentFiles>فایل های سند (*.mdc)|*.mdc</DocumentFiles>
    <EmfFiles>ابر فایل (*.emf)|*.emf</EmfFiles>
    <Excel2007Files>Microsoft Excel 2007/2013 فایل های (*.xlsx)|*.xlsx</Excel2007Files>
    <ExcelFiles>Microsoft Excel فایل های (*.xls)|*.xls</ExcelFiles>
    <ExcelXmlFiles>Microsoft Excel XML فایل های (*.xls)|*.xls</ExcelXmlFiles>
    <ExeFiles>EXE فایل های (*.exe)|*.exe</ExeFiles>
    <GifFiles>GIF تصویر (*.gif)|*.gif</GifFiles>
    <HtmlFiles>HTML فایل های (*.html)|*.html</HtmlFiles>
    <InheritedLanguageFiles>{0} فایل هایی برای زبان به ارث برده شده (*.{1})|*.{2}</InheritedLanguageFiles>
    <JpegFiles>JPEG تصویر (*.jpeg)|*.jpeg</JpegFiles>
    <LanguageFiles>{0} فایل های (*.{1})|*.{2}</LanguageFiles>
    <MetaFiles>فایل های متا</MetaFiles>
    <MhtFiles>MHT فایل های آرشسو وب (*.mht)|*.mht</MhtFiles>
    <PackedDocumentFiles>فایل های سند بسته بندی شده (*.mdz)|*.mdz</PackedDocumentFiles>
    <PackedReportFiles>فایل های گزارش بسته بندی شده (*.mrz)|*.mrz</PackedReportFiles>
    <PageFiles>فایل های صفحه (*.pg)|*.pg</PageFiles>
    <PdfFiles>Adobe PDF فایل های (*.pdf)|*.pdf</PdfFiles>
    <PngFiles>PNG تصویر (*.png)|*.png</PngFiles>
    <ReportFiles>فایل های گزارش (*.mrt)|*.mrt</ReportFiles>
    <RtfFiles>Rich Text متن (*.rtf)|*.rtf</RtfFiles>
    <StylesFiles>فایل های سبک (*.sts)|*.sts</StylesFiles>
    <TiffFiles>TIFF تصویر (*.tiff)|*.tiff</TiffFiles>
    <TxtFiles>متن (*.txt)|*.txt</TxtFiles>
    <Word2007Files>Microsoft Word 2007/2013 فایل های(*.docx)|*.docx</Word2007Files>
    <WriterFiles>بازکردن پرونده نویسنده (*.odt)|*.odt</WriterFiles>
    <XmlFiles>XML فایل های (*.xml)|*.xml</XmlFiles>
    <XpsFiles>Microsoft XPS فایل های(*.xps)|*.xps</XpsFiles>
  </FileFilters>
  <Formats>
    <custom01>d</custom01>
    <custom02>D</custom02>
    <custom03>f</custom03>
    <custom04>F</custom04>
    <custom05>yy/MM/dd</custom05>
    <custom06>yyyy/MM/dd</custom06>
    <custom07>G</custom07>
    <custom08>$0.00</custom08>
    <custom09>$0</custom09>
    <custom10>c</custom10>
    <custom11>c1</custom11>
    <custom12>c2</custom12>
    <custom13>#.00</custom13>
    <custom14>#,#</custom14>
    <custom15>n</custom15>
    <custom16>n1</custom16>
    <custom17>n2</custom17>
    <custom18>(###) ### - ####</custom18>
    <date01>*d</date01>
    <date02>*D</date02>
    <date03>M.dd</date03>
    <date04>yy.M.dd</date04>
    <date05>yy.MM.dd</date05>
    <date06>MMM.dd</date06>
    <date07>yy.MMM.dd</date07>
    <date08>yyyy, MMMM</date08>
    <date09>*f</date09>
    <date10>*F</date10>
    <date11>MM.dd.yyyy</date11>
    <date12>dd/MM/yyyy</date12>
    <time01>t</time01>
    <time02>T</time02>
    <time03>HH:mm</time03>
    <time04>H:mm</time04>
    <time06>HH:mm:ss</time06>
  </Formats>
  <FormBand>
    <AddFilter>&amp; اضافه کردن فیلتر</AddFilter>
    <AddGroup>&amp;اضافه کردن گروه</AddGroup>
    <AddResult>&amp;اضافه کردن نتیجه</AddResult>
    <AddSort>&amp;ضافه کردن گونه</AddSort>
    <And>and</And>
    <Ascending>صعودی</Ascending>
    <Descending>نزولی</Descending>
    <NoFilters>بدون فیلتر</NoFilters>
    <NoSort>بدون مرتب سازی</NoSort>
    <RemoveFilter>&amp;حذف فیلتر</RemoveFilter>
    <RemoveGroup>&amp;حذف گروه</RemoveGroup>
    <RemoveResult>&amp;حذف نتیجه</RemoveResult>
    <RemoveSort>&amp;حذف گونه</RemoveSort>
    <SortBy>مرتب سازی بر اساس:</SortBy>
    <ThenBy>سپس بوسیله</ThenBy>
    <title>برپا کردن اطلاعات</title>
  </FormBand>
  <FormColorBoxPopup>
    <Color>رنگ</Color>
    <Custom>سنت</Custom>
    <Others>بقیه...</Others>
    <System>سیستم</System>
    <Web>وب</Web>
  </FormColorBoxPopup>
  <FormConditions>
    <AaBbCcYyZz>AaBbCcYyZz</AaBbCcYyZz>
    <AddCondition>&amp;اضافه کردن شرط</AddCondition>
    <AddLevel>اضافه کردن سطح</AddLevel>
    <ChangeFont>...تغییر فونت</ChangeFont>
    <ComponentIsEnabled>بسته فعال است</ComponentIsEnabled>
    <NoConditions>بدون شرط</NoConditions>
    <RemoveCondition>&amp;حذف شرط</RemoveCondition>
    <SelectStyle>انتخاب شیوه</SelectStyle>
    <title>شروط</title>
  </FormConditions>
  <FormCrossTabDesigner>
    <Columns>ستون ها :</Columns>
    <DataSource>منبع داده:</DataSource>
    <Properties>خصوصیات:</Properties>
    <Rows>ردیف ها:</Rows>
    <Summary>خلاصه:</Summary>
    <Swap>تعویض ردیف ها/ستون ها</Swap>
    <title>Cross-Tab طراح</title>
  </FormCrossTabDesigner>
  <FormDatabaseEdit>
    <ConnectionString>رشته ارتباط:</ConnectionString>
    <DB2Edit> IBM DB2 ویرایش ارتباط</DB2Edit>
    <DB2New> IBM DB2 ارتباط جدید</DB2New>
    <FirebirdEdit> Firebird  ویرایش ارتباط</FirebirdEdit>
    <FirebirdNew>جدید Firebird ارتباط</FirebirdNew>
    <InitialCatalog>:کاتالوگ اولیه</InitialCatalog>
    <MySQLEdit>MySQL ویرایش ارتباط</MySQLEdit>
    <MySQLNew> MySQL ارتباط جدید</MySQLNew>
    <OdbcEdit> ODBC ویرایش ارتباط</OdbcEdit>
    <OdbcNew>جدید ODBC ارتباط</OdbcNew>
    <OleDbEdit> OLE DB ویرایش ارتباط</OleDbEdit>
    <OleDbNew>جدید OLE DB ارتباط</OleDbNew>
    <OracleEdit> Oracle ویرایش ارتباط</OracleEdit>
    <OracleNew>جدید Oracle ارتباط</OracleNew>
    <PathData>مسیر XML Data:</PathData>
    <PathSchema>مسیر XSD Schema:</PathSchema>
    <PostgreSQLEdit> PostgreSQL ویرایش ارتباط</PostgreSQLEdit>
    <PostgreSQLNew>جدید PostgreSQL ارتباط</PostgreSQLNew>
    <PromptUserNameAndPassword>مجوز نام و رمز کاربری</PromptUserNameAndPassword>
    <SqlCeEdit> SQLServerCE ویرایش ارتباط</SqlCeEdit>
    <SqlCeNew>SQLServerCE ارتباط جدید</SqlCeNew>
    <SqlEdit> SQL ویرایش ارتباط</SqlEdit>
    <SqlNew>جدید SQL ارتباط</SqlNew>
    <VistaDBEdit> VistaDB ویرایش ارتباط</VistaDBEdit>
    <VistaDBNew> VistaDB ارتباط جدید</VistaDBNew>
    <XmlEdit> XML ویرایش داده</XmlEdit>
    <XmlNew>جدید XML داده</XmlNew>
  </FormDatabaseEdit>
  <FormDesigner>
    <Others>بقیه</Others>
    <Code>کد</Code>
    <CompilingReport>گزارش در حال کامپایل است</CompilingReport>
    <HtmlPreview>HTML پیش نمایش</HtmlPreview>
    <LocalizePropertyGrid>محلی سازی دریچه خصوصیت</LocalizePropertyGrid>
    <OrderToolbars>سفارش جعبه ابزار</OrderToolbars>
    <Pages>صفحات</Pages>
    <Preview>پیش نمایش</Preview>
    <PropertyChange>تغییر خصوصیت {0}'</PropertyChange>
    <SetupToolbox>برپا کردن جعبه ابزار</SetupToolbox>
    <ShowDescription>نمایش توصیف</ShowDescription>
    <title>طراح</title>
  </FormDesigner>
  <FormDictionaryDesigner>
    <Actions>اعمال</Actions>
    <AutoSort>مرتب ساری اتوماتیک</AutoSort>
    <CalcColumnEdit>ویرایش ستون حساب شده</CalcColumnEdit>
    <CalcColumnNew>ستون حساب شده جدید</CalcColumnNew>
    <CategoryEdit> ویرایش دسته بندی</CategoryEdit>
    <CategoryNew>دسته بندی جدید</CategoryNew>
    <ChildSource>منبع داده فرزند:</ChildSource>
    <ColumnEdit>ویرایش ستون</ColumnEdit>
    <ColumnNew>ستون جدید</ColumnNew>
    <DatabaseEdit>ویرایش پایگاه داده</DatabaseEdit>
    <DatabaseNew>پایگاه داده جدید</DatabaseNew>
    <DataParameterEdit>ویرایش پارامتر</DataParameterEdit>
    <DataParameterNew>پارامتر جدید</DataParameterNew>
    <DataSourceEdit>ویرایش منبع داده</DataSourceEdit>
    <DataSourceNew>منبع داده جدید</DataSourceNew>
    <DataSourcesNew>منابع داده جدید</DataSourcesNew>
    <Delete>حذف</Delete>
    <DictionaryMerge>ادغام دیکشنری...</DictionaryMerge>
    <DictionaryNew>دیکشنری جدید...</DictionaryNew>
    <DictionaryOpen>باز کردن دیکشنری...</DictionaryOpen>
    <DictionarySaveAs>ذخیره دیکشنری با نام...</DictionarySaveAs>
    <EditQuery>ویرایش </EditQuery>
    <ExecutedSQLStatementSuccessfully>دستورات sql با موفقیت انجام شد</ExecutedSQLStatementSuccessfully>
    <GetColumnsFromAssembly>ستون را از اسمبلی بگیر</GetColumnsFromAssembly>
    <ImportRelations>ورود ارتباطات</ImportRelations>
    <MarkUsedItems>نشانه گذاری موارد استفاده شده</MarkUsedItems>
    <NewItem>مورد جدید</NewItem>
    <OpenAssembly>اسمبلی را باز کنید</OpenAssembly>
    <ParentSource>منبع داده والد:</ParentSource>
    <QueryText>متن درخواست</QueryText>
    <RelationEdit>ویرایش ارتباط</RelationEdit>
    <RelationNew>ارتباط جدید</RelationNew>
    <RetrieveColumns>بازیابی ستون ها </RetrieveColumns>
    <Run>اجرا</Run>
    <SortItems>مرتب کردن آیتم ها</SortItems>
    <SortOrder>نظم</SortOrder>
    <Synchronize>هم زمانی</Synchronize>
    <SynchronizeHint>همزمان کردن محتویات مخزن داده و محتویات دیکشنری</SynchronizeHint>
    <title>طراح دیکشنری</title>
    <VariableEdit>ویرایش متغیر</VariableEdit>
    <VariableNew>متغیر جدید</VariableNew>
    <ViewData>نمایش داده</ViewData>
    <ViewQuery>نمایش درخواست</ViewQuery>
  </FormDictionaryDesigner>
  <FormFormatEditor>
    <Boolean>بولی</Boolean>
    <BooleanDisplay>نمایش:</BooleanDisplay>
    <BooleanValue>مقدار:</BooleanValue>
    <Currency>رواج:</Currency>
    <CurrencySymbol>نشانه رواج:</CurrencySymbol>
    <Custom>سنت:</Custom>
    <Date>تاریخ:</Date>
    <DecimalDigits>اعداد دهدهی:</DecimalDigits>
    <DecimalSeparator>جدا کننده دهدهی:</DecimalSeparator>
    <FormatMask>قالب پوشش:</FormatMask>
    <Formats>قالب ها</Formats>
    <General>عموم</General>
    <GroupSeparator>جداکننده عمومی:</GroupSeparator>
    <GroupSize>اندازه گروه:</GroupSize>
    <nameFalse>غلط</nameFalse>
    <nameNo>خیر</nameNo>
    <nameOff>خاموش</nameOff>
    <nameOn>روشن</nameOn>
    <nameTrue>صحیح</nameTrue>
    <nameYes>بله</nameYes>
    <NegativePattern>الگوی منفی:</NegativePattern>
    <Number>عدد</Number>
    <Percentage>درصد</Percentage>
    <PercentageSymbol>نماد درصد:</PercentageSymbol>
    <PositivePattern>الگوی مثبت:</PositivePattern>
    <Properties>خصوصیات</Properties>
    <Sample>نمونه</Sample>
    <SampleText>متن نمونه</SampleText>
    <TextFormat>قالب متن</TextFormat>
    <Time>زمان</Time>
    <title>قالب</title>
    <UseGroupSeparator>استفاده از جدا کننده گروه</UseGroupSeparator>
    <UseLocalSetting>استفاده از تنظیمات محلی</UseLocalSetting>
  </FormFormatEditor>
  <FormGlobalizationEditor>
    <AddCulture>&amp;اضافه کردن فرهنگ</AddCulture>
    <AutoLocalizeReportOnRun>محلی کردن گزارش هنگام اجرا</AutoLocalizeReportOnRun>
    <RemoveCulture>&amp;حذف فرهنگ</RemoveCulture>
    <title>ویرایشگر عنوان</title>
  </FormGlobalizationEditor>
  <FormOptions>
    <AutoSave>ذخیره سازی اتوماتیک</AutoSave>
    <AutoSaveReportToReportClass>ذخیره سازی اتوماتیک گزارش در Vbیا C#</AutoSaveReportToReportClass>
    <Default>پیش فرض</Default>
    <Drawing>ترسیم</Drawing>
    <DrawMarkersWhenMoving>ترسیم نشانه گذارها هنگام حرکت</DrawMarkersWhenMoving>
    <EditAfterInsert>ویرایش بعد از الحاق</EditAfterInsert>
    <EnableAutoSaveMode>فعال سازی ذخیره سازی اتوماتیک</EnableAutoSaveMode>
    <FillBands>پرکردن حاشیه ها</FillBands>
    <FillComponents>پر کردن مولفه ها</FillComponents>
    <FillContainers>پر کردن حامل ها</FillContainers>
    <FillCrossBands>پرکردن نوارهای متقاطع</FillCrossBands>
    <GenerateLocalizedName>تولید نام محلی</GenerateLocalizedName>
    <Grid>پنجره</Grid>
    <GridDots>نقاط</GridDots>
    <GridLines>خطوط</GridLines>
    <GridMode>حالت دریچه</GridMode>
    <GridSize>اندازه دریچه</GridSize>
    <Main>اصلی</Main>
    <MarkersStyle>سبک نشانه گذارها</MarkersStyle>
    <MarkersStyleCorners>گوشه ها</MarkersStyleCorners>
    <MarkersStyleDashedRectangle>مستتطیل خط چین</MarkersStyleDashedRectangle>
    <MarkersStyleNone>هیچ چیز</MarkersStyleNone>
    <Minutes>{0} دقایق</Minutes>
    <SaveReportEvery>ذخیره گزارش هر</SaveReportEvery>
    <SelectUILanguage>انتخاب زبان واسط کاربر</SelectUILanguage>
    <ShowDimensionLines>نمایش خطوط ایعاد</ShowDimensionLines>
    <title>انتخاب</title>
    <UseComponentColor>استفاده از مولفه رنگ برای پرکردن </UseComponentColor>
    <UseLastFormat>استفاده از آخرین قالب</UseLastFormat>
  </FormOptions>
  <FormPageSetup>
    <ApplyTo>به کار بردن برای</ApplyTo>
    <Bottom>زیر:</Bottom>
    <Columns>ستون ها</Columns>
    <Height>ارتفاع:</Height>
    <Left>چپ:</Left>
    <Margins>حاشیه ها</Margins>
    <NumberOfColumns>تعداد ستون:</NumberOfColumns>
    <Orientation>جهت یابی</Orientation>
    <PageOrientationLandscape>چشم انداز</PageOrientationLandscape>
    <PageOrientationPortrait>تصویر</PageOrientationPortrait>
    <Paper>کاغذ:</Paper>
    <Right>راست:</Right>
    <ScaleContent>محتوای قیاس</ScaleContent>
    <Size>اندازه:</Size>
    <title>بر پا کردن صفحه</title>
    <Top>بالا:</Top>
    <Width>عرض:</Width>
  </FormPageSetup>
  <FormViewer>
    <Bookmarks>نشانواره ها</Bookmarks>
    <Close>بستن</Close>
    <CollapseAll>خرابی همه</CollapseAll>
    <ContextMenu>منوی محتوا</ContextMenu>
    <ExpandAll>گسترش همه</ExpandAll>
    <Export>صادرات</Export>
    <FirstPage>صفحه اول</FirstPage>
    <FullScreen>تمام صفحه</FullScreen>
    <HorScrollBar>میله پیمایش افقی</HorScrollBar>
    <LastPage>آخرین صفحه</LastPage>
    <NextPage>صفحه بعد</NextPage>
    <Open>باز کردن</Open>
    <PageControl>کنترل صفحه</PageControl>
    <PageDelete>حذف صفحه</PageDelete>
    <PageDesign>ویرایش صفحه</PageDesign>
    <PageNew>صفحه جدید</PageNew>
    <PageNofM>صفحه {0} از {1}</PageNofM>
    <PageNumber>شماره صفحه</PageNumber>
    <PageSize>سایز صفحه</PageSize>
    <PageViewModeContinuous>پیوسته</PageViewModeContinuous>
    <PageViewModeMultiplePages>چند صفحه ای</PageViewModeMultiplePages>
    <PageViewModeSinglePage>تک صفحه</PageViewModeSinglePage>
    <PrevPage>صفحه قبل</PrevPage>
    <Print>چاپ</Print>
    <qnPageDelete>میخواهید صفحه را پاک کنید؟</qnPageDelete>
    <Save>ذخیره</Save>
    <SendEMail>نامه الکترونیکی بفرست</SendEMail>
    <StatusBar>میله وضعیت</StatusBar>
    <Thumbnails>کوچک</Thumbnails>
    <title>پیش نمایش</title>
    <titlePageSettings>تنظیمات صفحه</titlePageSettings>
    <Toolbar>میله ابزار</Toolbar>
    <ToolEditor>ویرایشگر ابزار</ToolEditor>
    <ToolFind>پیدا کردن ابزار</ToolFind>
    <ToolHand>دست ابزار</ToolHand>
    <ToolSelect>انتخاب ابزار</ToolSelect>
    <VerScrollBar>میله پیمایش عمودی</VerScrollBar>
    <ViewMode>دیدن حالت</ViewMode>
    <Zoom>زوم</Zoom>
    <ZoomIn>زوم کن به جلو</ZoomIn>
    <ZoomMultiplePages>صفحات چند تایی</ZoomMultiplePages>
    <ZoomOnePage>یک صفحه</ZoomOnePage>
    <ZoomOut>زوم کن به عقب</ZoomOut>
    <ZoomPageWidth>عرض صفحه</ZoomPageWidth>
    <ZoomTwoPages>دوصفحه</ZoomTwoPages>
    <ZoomXXPages>{0} X {1} صفحات</ZoomXXPages>
    <ZoomXXPagesCancel>انصراف</ZoomXXPagesCancel>
  </FormViewer>
  <FormViewerFind>
    <Close>بستن</Close>
    <FindNext>پیدا کردن بعدی</FindNext>
    <FindWhat>کدام را پیدا کن:</FindWhat>
    <title>پیدا کردن</title>
  </FormViewerFind>
  <FormReportSetup>
    <ReportChanged>تغییر گزارش:</ReportChanged>
    <ReportCreated>ایجاد گزارش:</ReportCreated>
    <title>برپا کردن گزارش</title>
  </FormReportSetup>
  <FormRichTextEditor>
    <Bullets>گلوله</Bullets>
    <FontName>نام فونت</FontName>
    <FontSize>اندازه فونت</FontSize>
    <Insert>ورود عبارت</Insert>
    <title>Rich Text ویرایشگر</title>
  </FormRichTextEditor>
  <FormStyleDesigner>
    <Add>اضافه کردن سبک</Add>
    <Duplicate>روش دونسخه ای</Duplicate>
    <Open>باز کردن سبک</Open>
    <Remove>حذف سبک</Remove>
    <Save>ذخیره سبک</Save>
    <Style>سبک</Style>
    <title>طراح سبک</title>
  </FormStyleDesigner>
  <FormSystemTextEditor>
    <Condition>شرط</Condition>
    <LabelDataBand>باند داده:</LabelDataBand>
    <LabelDataColumn>ستون داده:</LabelDataColumn>
    <LabelSummaryFunction>تابع خلاصه:</LabelSummaryFunction>
    <pageExpression>عبارت</pageExpression>
    <pageSummary>خلاصه</pageSummary>
    <pageSystemVariable>متغیر سیستم</pageSystemVariable>
    <SummaryRunning>خلاصه اجرا</SummaryRunning>
    <SummaryRunningByColumn>ستون</SummaryRunningByColumn>
    <SummaryRunningByPage>صفحه</SummaryRunningByPage>
    <SummaryRunningByReport>گزارش</SummaryRunningByReport>
  </FormSystemTextEditor>
  <FormTitles>
    <ConditionEditorForm>شرط</ConditionEditorForm>
    <ConnectionSelectForm>نوع ارتباط را انتخاب کنید</ConnectionSelectForm>
    <ContainerSelectForm>انتخاب حامل</ContainerSelectForm>
    <DataAdapterServiceSelectForm>انتخاب نوع داده</DataAdapterServiceSelectForm>
    <DataRelationSelectForm>انتخاب ارتباط داده</DataRelationSelectForm>
    <DataSetName>ورود نام مجموعه داده</DataSetName>
    <DataSourceSelectForm>انتخاب منبع داده</DataSourceSelectForm>
    <DataSourcesNewForm>منبع داده جدید</DataSourcesNewForm>
    <DataStoreViewerForm>نمایشگر انبار داده</DataStoreViewerForm>
    <EventEditorForm>ویرایشگر واقعه</EventEditorForm>
    <ExpressionEditorForm>ویرایشگر عبارت</ExpressionEditorForm>
    <GroupConditionForm>شرط گروه</GroupConditionForm>
    <MasterComponentSelectForm>انتخاب مولفه اصلی</MasterComponentSelectForm>
    <PageAddForm>اضافه کردن صفحه</PageAddForm>
    <PageSizeForm>اندازه صفحه</PageSizeForm>
    <PagesManagerForm>مدیر صفحات</PagesManagerForm>
    <PromptForm>ورود اطلاعات برای دسترسی به پایگاه داده</PromptForm>
    <ServiceSelectForm>انتخاب سرویس</ServiceSelectForm>
    <SqlExpressionsForm>Sql عبارات</SqlExpressionsForm>
    <SubReportPageSelectForm>انتخاب صفحه زیر گزارش</SubReportPageSelectForm>
    <TextEditorForm>ویرایشگر متن</TextEditorForm>
    <ViewDataForm>داده را ببین</ViewDataForm>
  </FormTitles>
  <MainMenu>
    <menuContextClone>تکثیر...</menuContextClone>
    <menuContextDesign>طراحی...</menuContextDesign>
    <menuContextTextFormat>قالب متن...</menuContextTextFormat>
    <menuEdit>&amp;ویرایش</menuEdit>
    <menuEditCalcColumnNew>ستون حساب شده جدید...</menuEditCalcColumnNew>
    <menuEditCantRedo>عدم توان دوباره انجام دادن</menuEditCantRedo>
    <menuEditCantUndo> عدم توان دوباره بازگشتن</menuEditCantUndo>
    <menuEditCategoryNew>دسته بندی جدید...</menuEditCategoryNew>
    <menuEditClearContents>پاک کردن محتویات</menuEditClearContents>
    <menuEditColumnNew>ستون جدید...</menuEditColumnNew>
    <menuEditConnectionNew>ارتیاط جدید</menuEditConnectionNew>
    <menuEditCopy>&amp;کپی</menuEditCopy>
    <menuEditCut>برچیدن</menuEditCut>
    <menuEditDataParameterNew>پارامتر جدید</menuEditDataParameterNew>
    <menuEditDataSourceNew>منبع داده جدید....</menuEditDataSourceNew>
    <menuEditDataSourcesNew>منبع داده جدید...</menuEditDataSourcesNew>
    <menuEditDelete>&amp;حذف</menuEditDelete>
    <menuEditEdit>ویرایش</menuEditEdit>
    <menuEditImportRelations>وارد کردن ارتباط...</menuEditImportRelations>
    <menuEditPaste>&amp;گذاشتن</menuEditPaste>
    <menuEditRedo>&amp;دوباره انجام دادن</menuEditRedo>
    <menuEditRedoText>&amp;دوباره انجام دادن {0}</menuEditRedoText>
    <menuEditRelationNew>ارتباط جدید</menuEditRelationNew>
    <menuEditRemoveUnused>حذف موارد استفاده نشده</menuEditRemoveUnused>
    <menuEditSelectAll>انتخاب همه</menuEditSelectAll>
    <menuEditSynchronize>هم زمانی</menuEditSynchronize>
    <menuEditUndo>&amp;بی اثر کردن</menuEditUndo>
    <menuEditUndoText>&amp;بی اثر کردن {0}</menuEditUndoText>
    <menuEditVariableNew>متغیر جدید...</menuEditVariableNew>
    <menuEditViewData>دیدن داده...</menuEditViewData>
    <menuFile>&amp;فایل</menuFile>
    <menuFileExit>خروج</menuFileExit>
    <menuFileExportXMLSchema>صدور XML Schema...</menuFileExportXMLSchema>
    <menuFileFormNew>فرم جدید</menuFileFormNew>
    <menuFileImportXMLSchema>ورود XML Schema...</menuFileImportXMLSchema>
    <menuFileMerge>به هم چسباندن</menuFileMerge>
    <menuFileMergeXMLSchema>ادغام XML Schema...</menuFileMergeXMLSchema>
    <menuFileNew>جدید</menuFileNew>
    <menuFileOpen>باز کردن...</menuFileOpen>
    <menuFilePageDelete>حذف صفحه</menuFilePageDelete>
    <menuFilePageNew>صفحه جدید</menuFilePageNew>
    <menuFilePageOpen>باز کردن صفحه...</menuFilePageOpen>
    <menuFilePageSaveAs>دخیره صفحه به نام...</menuFilePageSaveAs>
    <menuFilePageSetup>برپا کردن صفحه</menuFilePageSetup>
    <menuFileReportNew>گزارش جدید</menuFileReportNew>
    <menuFileReportOpen>باز کردن گزارش</menuFileReportOpen>
    <menuFileReportPreview>پیش نمایش</menuFileReportPreview>
    <menuFileReportSave>ذخیره گزارش</menuFileReportSave>
    <menuFileReportSaveAs>ذخیره گزارش با نام</menuFileReportSaveAs>
    <menuFileReportSetup>بر پایی گزارش</menuFileReportSetup>
    <menuFileSaveAs>ذخیره با نام</menuFileSaveAs>
    <menuHelp>کمک</menuHelp>
    <menuHelpAboutProgramm>درباره </menuHelpAboutProgramm>
    <menuHelpContents>محتویات</menuHelpContents>
    <menuHelpFAQPage>FAQ صفحه</menuHelpFAQPage>
    <menuHelpHowToRegister>چگونه ثبت نام کنید</menuHelpHowToRegister>
    <menuHelpProductHomePage>تولید صفحه خانگی</menuHelpProductHomePage>
    <menuHelpSupport>حمایت</menuHelpSupport>
    <menuTools>ابزار</menuTools>
    <menuToolsDataStore>مخزن داده...</menuToolsDataStore>
    <menuToolsDictionary>دیکشنری...</menuToolsDictionary>
    <menuToolsOptions>&amp;انتخاب...</menuToolsOptions>
    <menuToolsPagesManager>&amp;مدیر صفحات...</menuToolsPagesManager>
    <menuToolsServicesConfigurator>تنظیم کننده خدمات</menuToolsServicesConfigurator>
    <menuToolsStyleDesigner>طراح سبک</menuToolsStyleDesigner>
    <menuView>دید</menuView>
    <menuViewAlignToGrid>هم تراز کردن با پنجره</menuViewAlignToGrid>
    <menuViewLockDockingPanels>قفل جاخا لی های صفحات</menuViewLockDockingPanels>
    <menuViewLockToolbars>قفل نوار ابزار</menuViewLockToolbars>
    <menuViewNormal>&amp;عادی</menuViewNormal>
    <menuViewPageBreakPreview>صفحه جدا کردن پیش نمایش</menuViewPageBreakPreview>
    <menuViewQuickInfo>اطلاع سریع</menuViewQuickInfo>
    <menuViewQuickInfoNone>هیچ</menuViewQuickInfoNone>
    <menuViewQuickInfoOverlay>نمایش مولفه های بیشتر</menuViewQuickInfoOverlay>
    <menuViewQuickInfoShowAliases>نمایش نام مستعار</menuViewQuickInfoShowAliases>
    <menuViewQuickInfoShowComponentsNames>نمایش نام مولفه ها</menuViewQuickInfoShowComponentsNames>
    <menuViewQuickInfoShowContent>نمایش محتوا</menuViewQuickInfoShowContent>
    <menuViewQuickInfoShowEvents>نمایش وقایع</menuViewQuickInfoShowEvents>
    <menuViewQuickInfoShowFields>نمایش زمینه ها</menuViewQuickInfoShowFields>
    <menuViewQuickInfoShowFieldsOnly>فقط نمایش زمینه ها</menuViewQuickInfoShowFieldsOnly>
    <menuViewShowGrid>نمایش پنجره</menuViewShowGrid>
    <menuViewShowHeaders>نمایش سرصفحه</menuViewShowHeaders>
    <menuViewShowOrder>نمایش سفارش</menuViewShowOrder>
    <menuViewShowRulers>نمایش خطکش ها</menuViewShowRulers>
    <menuViewToolbars>نوار ابزار</menuViewToolbars>
  </MainMenu>
  <Panels>
    <Dictionary>دیکشنری</Dictionary>
    <Messages>پیغام ها</Messages>
    <Properties>خصوصیات</Properties>
    <ReportTree>درخت گزارش</ReportTree>
  </Panels>
  <PropertyCategory>
    <AppearanceCategory>ظاهر</AppearanceCategory>
    <ArgumentCategory>آرگومان</ArgumentCategory>
    <BarCodeAdditionalCategory>نوار کد اضافه</BarCodeAdditionalCategory>
    <BarCodeCategory>نوار کد</BarCodeCategory>
    <BehaviorCategory>رفتار</BehaviorCategory>
    <ChartAdditionalCategory>جدول اضافه</ChartAdditionalCategory>
    <ChartCategory>نمودار</ChartCategory>
    <CheckCategory>چک</CheckCategory>
    <ColorsCategory>رنگ ها</ColorsCategory>
    <ColumnsCategory>ستون ها</ColumnsCategory>
    <ControlCategory>کنترل</ControlCategory>
    <ControlsEventsCategory>کنترل کردن وقایع</ControlsEventsCategory>
    <CrossTabCategory>باریکه ضربدری</CrossTabCategory>
    <DataCategory>داده</DataCategory>
    <DesignCategory>طراحی</DesignCategory>
    <DisplayCategory>نمایش</DisplayCategory>
    <ExportCategory>وارد کردن</ExportCategory>
    <ExportEventsCategory>صادر کردن وقایع</ExportEventsCategory>
    <HierarchicalCategory>سلسله مراتبی</HierarchicalCategory>
    <ImageAdditionalCategory>تصویر اضافی</ImageAdditionalCategory>
    <ImageCategory>تصویر</ImageCategory>
    <MainCategory>اصلی</MainCategory>
    <MarkerCategory>نشانه گذار</MarkerCategory>
    <MiscCategory>مختلف</MiscCategory>
    <MouseEventsCategory>وقایع موس</MouseEventsCategory>
    <NavigationCategory>شناور بودن</NavigationCategory>
    <NavigationEventsCategory>وقایع شناور بودن</NavigationEventsCategory>
    <OptionsCategory>انتخاب ها</OptionsCategory>
    <PageAdditionalCategory>صفحه اضافی</PageAdditionalCategory>
    <PageCategory>صفحه</PageCategory>
    <ParametersCategory>پارامتر</ParametersCategory>
    <PositionCategory>موقعیت</PositionCategory>
    <PrimitiveCategory>اولیه</PrimitiveCategory>
    <PrintEventsCategory>چاپ وقایع</PrintEventsCategory>
    <RenderEventsCategory>ارائه وقایع</RenderEventsCategory>
    <ShapeCategory>شکل</ShapeCategory>
    <SubReportCategory>زیر گزارش</SubReportCategory>
    <TextAdditionalCategory>متن اضافی</TextAdditionalCategory>
    <TextCategory>متن</TextCategory>
    <TitleCategory>عنوان</TitleCategory>
    <ValueCategory>ارزش</ValueCategory>
    <ValueEndCategory>مقدار پایانی</ValueEndCategory>
    <ValueEventsCategory>مقدار وقایع</ValueEventsCategory>
    <WinControlCategory>Win کنترل</WinControlCategory>
    <ZipCodeCategory>کد فشرده</ZipCodeCategory>
  </PropertyCategory>
  <PropertyColor>
    <AliceBlue>آبی آلیسی</AliceBlue>
    <AntiqueWhite>سفید باستانی</AntiqueWhite>
    <Aqua>اب و زلال</Aqua>
    <Aquamarine>زرد کبود</Aquamarine>
    <Azure>لاجوردی</Azure>
    <Beige>قهوه ای مایل به زرد</Beige>
    <Bisque>رنگ گوشت پخته</Bisque>
    <Black>مشکی</Black>
    <BlanchedAlmond>بادامی کمرنگ</BlanchedAlmond>
    <Blue>ابی</Blue>
    <BlueViolet>آبی مایل به بنفش</BlueViolet>
    <Brown>قهوه ای</Brown>
    <BurlyWood>قهوه ای گره دار</BurlyWood>
    <CadetBlue>آبی افسری</CadetBlue>
    <Chartreuse>سبز زرد</Chartreuse>
    <Chocolate>شکلاتی</Chocolate>
    <Coral>مرجانی</Coral>
    <CornflowerBlue>آبی روشن</CornflowerBlue>
    <Cornsilk>ابریشمی دانه دار</Cornsilk>
    <Crimson>قرمز لاکی</Crimson>
    <Cyan>آبی مایل به سبز</Cyan>
    <DarkBlue>آبی تیره</DarkBlue>
    <DarkCyan>آبی مایل به سبز تیره</DarkCyan>
    <DarkGoldenrod>طلایی تیره</DarkGoldenrod>
    <DarkGray>خاکستری تیره</DarkGray>
    <DarkGreen>سبز تیره</DarkGreen>
    <DarkKhaki>خاکی تیره</DarkKhaki>
    <DarkMagenta>سرخ تیره</DarkMagenta>
    <DarkOliveGreen>سبز زیتونی تیره</DarkOliveGreen>
    <DarkOrange>نارنجی تیره</DarkOrange>
    <DarkOrchid>ارغوانی تیره</DarkOrchid>
    <DarkRed>قرمز تیره</DarkRed>
    <DarkSalmon>قزل آلایی تیره</DarkSalmon>
    <DarkSeaGreen>سبز دریای تیره</DarkSeaGreen>
    <DarkSlateBlue>آبی سنگی تیره</DarkSlateBlue>
    <DarkSlateGray>خاکستری سنگی تیره</DarkSlateGray>
    <DarkTurquoise>فیروزه ای تیره</DarkTurquoise>
    <DarkViolet>بنفش تیره</DarkViolet>
    <DeepPink>صورتی ژرف </DeepPink>
    <DeepSkyBlue>آبی آسمانی ژرف</DeepSkyBlue>
    <DimGray>خاکستری تار</DimGray>
    <DodgerBlue>آبی خال دار</DodgerBlue>
    <Firebrick>آجری</Firebrick>
    <FloralWhite>سفید گلدار</FloralWhite>
    <ForestGreen>سبز جنگلی</ForestGreen>
    <Fuchsia>فوکسید</Fuchsia>
    <Gainsboro>خاکستری</Gainsboro>
    <GhostWhite>سفید روحی</GhostWhite>
    <Gold>طلایی</Gold>
    <Goldenrod>زرد طلایی</Goldenrod>
    <Gray>خاکستری</Gray>
    <Green>سبز</Green>
    <GreenYellow>زرد سبز</GreenYellow>
    <Honeydew>عسلی</Honeydew>
    <HotPink>صورتی تند</HotPink>
    <IndianRed>قرمز هندی</IndianRed>
    <Indigo>نیلی</Indigo>
    <Ivory>عاجی</Ivory>
    <Khaki>خاکی</Khaki>
    <Lavender>سنبلی</Lavender>
    <LavenderBlush>سنبلی مایل به سرخ</LavenderBlush>
    <LawnGreen>سبز چمنی</LawnGreen>
    <LemonChiffon>ابریشمی لیمویی</LemonChiffon>
    <LightBlue>آبی روشن</LightBlue>
    <LightCoral>مرجانی روشن</LightCoral>
    <LightCyan>آبی مایل به سبز روشن</LightCyan>
    <LightGoldenrodYellow>زرد طلایی روشن</LightGoldenrodYellow>
    <LightGray>خاکستری روشن</LightGray>
    <LightGreen>سبز روشن</LightGreen>
    <LightPink>صورتی روشن</LightPink>
    <LightSalmon>قزل الایی روشن</LightSalmon>
    <LightSeaGreen>سبز دریایی روشن</LightSeaGreen>
    <LightSkyBlue>آبی آسمانی روشن</LightSkyBlue>
    <LightSlateGray>خاکستری رنگی روشن</LightSlateGray>
    <LightSteelBlue>آبی پولادی روشن</LightSteelBlue>
    <LightYellow>زرد روشن</LightYellow>
    <Lime>آهکی</Lime>
    <LimeGreen>سبز آهکی</LimeGreen>
    <Linen>کتانی</Linen>
    <Magenta>مایل به سرخ</Magenta>
    <Maroon>بلوطی</Maroon>
    <MediumAquamarine>فام متوسط</MediumAquamarine>
    <MediumBlue>آبی متوسط</MediumBlue>
    <MediumOrchid>ارغوانی متوسط</MediumOrchid>
    <MediumPurple>بنفش متوسط</MediumPurple>
    <MediumSeaGreen>سبز دریایی متوسط</MediumSeaGreen>
    <MediumSlateBlue>آبی سنگی متوسط</MediumSlateBlue>
    <MediumSpringGreen>سبز بهاری متوسط</MediumSpringGreen>
    <MediumTurquoise>فیروزه ای متوسط</MediumTurquoise>
    <MediumVioletRed>قرمز بنفش متوسط</MediumVioletRed>
    <MidnightBlue>آبی نیمه شب</MidnightBlue>
    <MintCream>کرمی ناخالص</MintCream>
    <MistyRose>سرخ مه دار</MistyRose>
    <Moccasin>پوست ماری</Moccasin>
    <NavajoWhite>متمایل به سفید</NavajoWhite>
    <Navy>دریایی</Navy>
    <OldLace>توری کهنه</OldLace>
    <Olive>زیتونی</Olive>
    <OliveDrab>خاکستری زیتونی</OliveDrab>
    <Orange>نارنجی</Orange>
    <OrangeRed>قرمز نارنجی</OrangeRed>
    <Orchid>ارغوانی</Orchid>
    <PaleGoldenrod>زردطلایی کمرنگ</PaleGoldenrod>
    <PaleGreen>سبز میله ای</PaleGreen>
    <PaleTurquoise>قزل آلای میله ای</PaleTurquoise>
    <PaleVioletRed>قرمز بنفش میله ای</PaleVioletRed>
    <PapayaWhip>عنبه ای</PapayaWhip>
    <PeachPuff>هلویی</PeachPuff>
    <Peru>Peru</Peru>
    <Pink>صورتی</Pink>
    <Plum>گوجه ای</Plum>
    <PowderBlue>آبی پودری</PowderBlue>
    <Purple>ارغوانی</Purple>
    <Red>قرمز</Red>
    <RosyBrown>قهوه ای سرخ رنگ</RosyBrown>
    <RoyalBlue>آبی سلطنتی</RoyalBlue>
    <SaddleBrown>قهوه ای زین اسبی</SaddleBrown>
    <Salmon>قزل آلایی</Salmon>
    <SandyBrown>قهوه ای ماسه ای</SandyBrown>
    <SeaGreen>سبز دریایی</SeaGreen>
    <SeaShell>سبوسی دریایی</SeaShell>
    <Sienna>قهوهای مایل به زرد</Sienna>
    <Silver>نقره ای</Silver>
    <SkyBlue>آبی آسمانی</SkyBlue>
    <SlateBlue>آبی سنگی</SlateBlue>
    <SlateGray>خاکستری سنگی</SlateGray>
    <Snow>برفی</Snow>
    <SpringGreen>سبز بهاری</SpringGreen>
    <SteelBlue>آبی استیلی</SteelBlue>
    <Tan>برنزه</Tan>
    <Teal>مرغابی</Teal>
    <Thistle>خاری</Thistle>
    <Tomato>گوجه ای</Tomato>
    <Transparent>شفاف</Transparent>
    <Turquoise>فیروزه ای</Turquoise>
    <Violet>بنفش</Violet>
    <Wheat>گندمی</Wheat>
    <White>سفید</White>
    <WhiteSmoke>سفید دودی</WhiteSmoke>
    <Yellow>زرد</Yellow>
    <YellowGreen>سبز زردی</YellowGreen>
  </PropertyColor>
  <PropertyEnum>
    <boolFalse>غلط</boolFalse>
    <boolTrue>صحیح</boolTrue>
    <BorderStyleFixed3D>ثابت سه بعدی</BorderStyleFixed3D>
    <BorderStyleFixedSingle>تنهای  ثابت</BorderStyleFixedSingle>
    <BorderStyleNone>هیچ</BorderStyleNone>
    <ChartAxesTicksAll>همه</ChartAxesTicksAll>
    <ChartAxesTicksMajor>اصلی</ChartAxesTicksMajor>
    <ChartAxesTicksNone>هیچ</ChartAxesTicksNone>
    <ChartGridLinesAll>همه</ChartGridLinesAll>
    <ChartGridLinesMajor>اصلی</ChartGridLinesMajor>
    <ChartGridLinesNone>هیچ</ChartGridLinesNone>
    <ComboBoxStyleDropDown>کشش به پایین</ComboBoxStyleDropDown>
    <ComboBoxStyleDropDownList> لیست کشش به پایین</ComboBoxStyleDropDownList>
    <ComboBoxStyleSimple>ساده</ComboBoxStyleSimple>
    <ContentAlignmentBottomCenter>مرکز پایین</ContentAlignmentBottomCenter>
    <ContentAlignmentBottomLeft>چپ پایین</ContentAlignmentBottomLeft>
    <ContentAlignmentBottomRight>راست پایین</ContentAlignmentBottomRight>
    <ContentAlignmentMiddleCenter>مرکز وسط</ContentAlignmentMiddleCenter>
    <ContentAlignmentMiddleLeft>جپ وسط</ContentAlignmentMiddleLeft>
    <ContentAlignmentMiddleRight>راست وسط</ContentAlignmentMiddleRight>
    <ContentAlignmentTopCenter>مرکز بالا</ContentAlignmentTopCenter>
    <ContentAlignmentTopLeft>چپ بالا</ContentAlignmentTopLeft>
    <ContentAlignmentTopRight>راست بالا</ContentAlignmentTopRight>
    <DataGridLineStyleNone>هیچ</DataGridLineStyleNone>
    <DataGridLineStyleSolid>قوی و پر</DataGridLineStyleSolid>
    <DateTimePickerFormatCustom>سنتی</DateTimePickerFormatCustom>
    <DateTimePickerFormatLong>بلند</DateTimePickerFormatLong>
    <DateTimePickerFormatShort>کوتاه</DateTimePickerFormatShort>
    <DateTimePickerFormatTime>زمان</DateTimePickerFormatTime>
    <DialogResultAbort>قطع کن</DialogResultAbort>
    <DialogResultCancel>انصراف</DialogResultCancel>
    <DialogResultIgnore>بگذر</DialogResultIgnore>
    <DialogResultNo>خیر</DialogResultNo>
    <DialogResultNone>هیچ</DialogResultNone>
    <DialogResultOK>تایید</DialogResultOK>
    <DialogResultRetry>دوباره سعی کردن</DialogResultRetry>
    <DialogResultYes>بله</DialogResultYes>
    <DockStyleBottom>پایین</DockStyleBottom>
    <DockStyleFill>پر کردن</DockStyleFill>
    <DockStyleLeft>چپ</DockStyleLeft>
    <DockStyleNone>هیچ</DockStyleNone>
    <DockStyleRight>راست</DockStyleRight>
    <DockStyleTop>بالا</DockStyleTop>
    <FormStartPositionCenterParent>والد مرکزی</FormStartPositionCenterParent>
    <FormStartPositionCenterScreen>صفحه مرکزی</FormStartPositionCenterScreen>
    <FormStartPositionManual>دستی</FormStartPositionManual>
    <FormStartPositionWindowsDefaultBounds>مرزهای پیش فرض پنجره</FormStartPositionWindowsDefaultBounds>
    <FormStartPositionWindowsDefaultLocation>مکان پیش فرض پنجره</FormStartPositionWindowsDefaultLocation>
    <FormWindowStateMaximized>بیشینه شده</FormWindowStateMaximized>
    <FormWindowStateMinimized>کمینه شده</FormWindowStateMinimized>
    <FormWindowStateNormal>عادی</FormWindowStateNormal>
    <HorizontalAlignmentCenter>مرکز</HorizontalAlignmentCenter>
    <HorizontalAlignmentLeft>چپ</HorizontalAlignmentLeft>
    <HorizontalAlignmentRight>راست</HorizontalAlignmentRight>
    <HotkeyPrefixHide>پنهان کردن</HotkeyPrefixHide>
    <HotkeyPrefixNone>هیچ</HotkeyPrefixNone>
    <HotkeyPrefixShow>نمایش دادن</HotkeyPrefixShow>
    <LeftRightAlignmentLeft>چپ</LeftRightAlignmentLeft>
    <LeftRightAlignmentRight>راست</LeftRightAlignmentRight>
    <PictureBoxSizeModeAutoSize>اندازه اتوماتیکی</PictureBoxSizeModeAutoSize>
    <PictureBoxSizeModeCenterImage>تصویر مرکزی</PictureBoxSizeModeCenterImage>
    <PictureBoxSizeModeNormal>عادی</PictureBoxSizeModeNormal>
    <PictureBoxSizeModeStretchImage>تصویر را بکش</PictureBoxSizeModeStretchImage>
    <RightToLeftInherit>به ارث بردن</RightToLeftInherit>
    <RightToLeftNo>خیر</RightToLeftNo>
    <RightToLeftYes>بله</RightToLeftYes>
    <SelectionModeMultiExtended>چند گستره</SelectionModeMultiExtended>
    <SelectionModeMultiSimple>چند سادگی</SelectionModeMultiSimple>
    <SelectionModeNone>هیچ</SelectionModeNone>
    <SelectionModeOne>یک</SelectionModeOne>
    <StiAngleAngle0>0 درجه</StiAngleAngle0>
    <StiAngleAngle180>180 درجه</StiAngleAngle180>
    <StiAngleAngle270>270 درجه</StiAngleAngle270>
    <StiAngleAngle45>45 درجه</StiAngleAngle45>
    <StiAngleAngle90>90 درجه</StiAngleAngle90>
    <StiArrowStyleLines>خطوط</StiArrowStyleLines>
    <StiArrowStyleNone>هیچ</StiArrowStyleNone>
    <StiArrowStyleTriangle>مثلث</StiArrowStyleTriangle>
    <StiBorderSidesAll>همه</StiBorderSidesAll>
    <StiBorderSidesBottom>پایین</StiBorderSidesBottom>
    <StiBorderSidesLeft>چپ</StiBorderSidesLeft>
    <StiBorderSidesNone>هیچ</StiBorderSidesNone>
    <StiBorderSidesRight>راست</StiBorderSidesRight>
    <StiBorderSidesTop>بالا</StiBorderSidesTop>
    <StiBorderStyleBump>ضربت</StiBorderStyleBump>
    <StiBorderStyleEtched>منقوش</StiBorderStyleEtched>
    <StiBorderStyleFlat>یک دست</StiBorderStyleFlat>
    <StiBorderStyleNone>هیچ</StiBorderStyleNone>
    <StiBorderStyleRaised>ترفیع</StiBorderStyleRaised>
    <StiBorderStyleRaisedInner>ترفیع داخلی</StiBorderStyleRaisedInner>
    <StiBorderStyleRaisedOuter>ترفیع خارجی</StiBorderStyleRaisedOuter>
    <StiBorderStyleSunken>فرو رفته</StiBorderStyleSunken>
    <StiBorderStyleSunkenInner>فرورفته داخلی</StiBorderStyleSunkenInner>
    <StiBorderStyleSunkenOuter>فرورفته خارجی</StiBorderStyleSunkenOuter>
    <StiChartTitleDockBottom>پایین</StiChartTitleDockBottom>
    <StiChartTitleDockLeft>چپ</StiChartTitleDockLeft>
    <StiChartTitleDockRight>راست</StiChartTitleDockRight>
    <StiChartTitleDockTop>بالا</StiChartTitleDockTop>
    <StiCheckStyleCheck>چک کردن</StiCheckStyleCheck>
    <StiCheckStyleCheckRectangle>مستطیل چک</StiCheckStyleCheckRectangle>
    <StiCheckStyleCross>پیوند</StiCheckStyleCross>
    <StiCheckStyleCrossCircle>دایره پیوندی</StiCheckStyleCrossCircle>
    <StiCheckStyleCrossRectangle> مستطیل پیوندی</StiCheckStyleCrossRectangle>
    <StiCheckStyleDotCircle>دایره نقطه دار</StiCheckStyleDotCircle>
    <StiCheckStyleDotRectangle>مستطیل نقطه دار</StiCheckStyleDotRectangle>
    <StiCheckStyleNone>پوچ</StiCheckStyleNone>
    <StiCheckStyleNoneCircle>دایره پوچ</StiCheckStyleNoneCircle>
    <StiCheckStyleNoneRectangle>مستطیل پوچ</StiCheckStyleNoneRectangle>
    <StiCheckSumNo>خیر</StiCheckSumNo>
    <StiCheckSumYes>بالا</StiCheckSumYes>
    <StiColumnDirectionAcrossThenDown>سرتاسر سپس پایین</StiColumnDirectionAcrossThenDown>
    <StiColumnDirectionDownThenAcross>پایین سپس سرتاسر</StiColumnDirectionDownThenAcross>
    <StiCrossHorAlignmentCenter>Center</StiCrossHorAlignmentCenter>
    <StiCrossHorAlignmentLeft>Left</StiCrossHorAlignmentLeft>
    <StiCrossHorAlignmentNone>None</StiCrossHorAlignmentNone>
    <StiCrossHorAlignmentRight>Right</StiCrossHorAlignmentRight>
    <StiEmptySizeModeAlignFooterToBottom>تنظیم زیرنویس به پایین</StiEmptySizeModeAlignFooterToBottom>
    <StiEmptySizeModeAlignFooterToTop>تنظیم زیرنویس به بالا</StiEmptySizeModeAlignFooterToTop>
    <StiEmptySizeModeDecreaseLastRow>کاهش آخرین ردیف</StiEmptySizeModeDecreaseLastRow>
    <StiEmptySizeModeIncreaseLastRow>افزایش آخرین ردیف</StiEmptySizeModeIncreaseLastRow>
    <StiEnumeratorTypeABC>ABC</StiEnumeratorTypeABC>
    <StiEnumeratorTypeArabic>عربی</StiEnumeratorTypeArabic>
    <StiEnumeratorTypeNone>هیچ</StiEnumeratorTypeNone>
    <StiEnumeratorTypeRoman>رومان</StiEnumeratorTypeRoman>
    <StiFilterConditionBeginningWith>شروع با</StiFilterConditionBeginningWith>
    <StiFilterConditionBetween>بین</StiFilterConditionBetween>
    <StiFilterConditionContaining>شامل</StiFilterConditionContaining>
    <StiFilterConditionEndingWith>تمام شدن یا</StiFilterConditionEndingWith>
    <StiFilterConditionEqualTo>برایر یا</StiFilterConditionEqualTo>
    <StiFilterConditionGreaterThan>بزرگتر از</StiFilterConditionGreaterThan>
    <StiFilterConditionGreaterThanOrEqualTo>بزرگتر مساوی با</StiFilterConditionGreaterThanOrEqualTo>
    <StiFilterConditionLessThan>کمتر از</StiFilterConditionLessThan>
    <StiFilterConditionLessThanOrEqualTo>کمتر مساوی با</StiFilterConditionLessThanOrEqualTo>
    <StiFilterConditionNotBetween>مابین نباشد</StiFilterConditionNotBetween>
    <StiFilterConditionNotContaining>شامل نباشد</StiFilterConditionNotContaining>
    <StiFilterConditionNotEqualTo>برابر نباشد</StiFilterConditionNotEqualTo>
    <StiFilterDataTypeBoolean>دوتایی</StiFilterDataTypeBoolean>
    <StiFilterDataTypeDateTime>ساعت تاریخ</StiFilterDataTypeDateTime>
    <StiFilterDataTypeExpression>عبارت</StiFilterDataTypeExpression>
    <StiFilterDataTypeNumeric>عددی</StiFilterDataTypeNumeric>
    <StiFilterDataTypeString>رشته</StiFilterDataTypeString>
    <StiFilterItemArgument>آرگومان</StiFilterItemArgument>
    <StiFilterItemExpression>عبارت</StiFilterItemExpression>
    <StiFilterItemValue>ارزش</StiFilterItemValue>
    <StiFilterModeAnd>و</StiFilterModeAnd>
    <StiFilterModeOr>یا</StiFilterModeOr>
    <StiFormStartModeOnEnd>در انتها</StiFormStartModeOnEnd>
    <StiFormStartModeOnPreview>در پیش نمایش</StiFormStartModeOnPreview>
    <StiFormStartModeOnStart>در شروع</StiFormStartModeOnStart>
    <StiGroupSortDirectionAscending>صعودی</StiGroupSortDirectionAscending>
    <StiGroupSortDirectionDescending>نزولی</StiGroupSortDirectionDescending>
    <StiGroupSortDirectionNone>هیج</StiGroupSortDirectionNone>
    <StiHorAlignmentCenter>مرکز</StiHorAlignmentCenter>
    <StiHorAlignmentLeft>چپ</StiHorAlignmentLeft>
    <StiHorAlignmentRight>راست</StiHorAlignmentRight>
    <StiLabelsPlacementNone>هیچ</StiLabelsPlacementNone>
    <StiLabelsPlacementOneLine>یک خط</StiLabelsPlacementOneLine>
    <StiLabelsPlacementTwoLines>دو خط</StiLabelsPlacementTwoLines>
    <StiLegendDirectionBottomToTop>پایین به بالا</StiLegendDirectionBottomToTop>
    <StiLegendDirectionLeftToRight>چپ به راست</StiLegendDirectionLeftToRight>
    <StiLegendDirectionRightToLeft>راست به چپ</StiLegendDirectionRightToLeft>
    <StiLegendDirectionTopToBottom>بالا به پایین</StiLegendDirectionTopToBottom>
    <StiLegendHorAlignmentCenter>مرکز</StiLegendHorAlignmentCenter>
    <StiLegendHorAlignmentLeft>چپ</StiLegendHorAlignmentLeft>
    <StiLegendHorAlignmentLeftOutside>چپ بیرون</StiLegendHorAlignmentLeftOutside>
    <StiLegendHorAlignmentRight>راست</StiLegendHorAlignmentRight>
    <StiLegendHorAlignmentRightOutside>راست بیرون</StiLegendHorAlignmentRightOutside>
    <StiLegendVertAlignmentBottom>پایین</StiLegendVertAlignmentBottom>
    <StiLegendVertAlignmentBottomOutside>پایین بیرون</StiLegendVertAlignmentBottomOutside>
    <StiLegendVertAlignmentCenter>مرکز</StiLegendVertAlignmentCenter>
    <StiLegendVertAlignmentTop>بالا</StiLegendVertAlignmentTop>
    <StiLegendVertAlignmentTopOutside>بالا بیرون</StiLegendVertAlignmentTopOutside>
    <StiMarkerAlignmentLeft>چپ</StiMarkerAlignmentLeft>
    <StiMarkerAlignmentRight>راست</StiMarkerAlignmentRight>
    <StiMarkerTypeCircle>دایره</StiMarkerTypeCircle>
    <StiMarkerTypeRectangle>مستطیل</StiMarkerTypeRectangle>
    <StiMarkerTypeTriangle>مثلث</StiMarkerTypeTriangle>
    <StiNumberOfPassDoublePass>دو گذره</StiNumberOfPassDoublePass>
    <StiNumberOfPassSinglePass>تک گدره</StiNumberOfPassSinglePass>
    <StiOrientationHorizontal>افقی</StiOrientationHorizontal>
    <StiOrientationVertical>عمودی</StiOrientationVertical>
    <StiPageOrientationLandscape>چشم انداز</StiPageOrientationLandscape>
    <StiPageOrientationPortrait>تصویر</StiPageOrientationPortrait>
    <StiPenStyleDash>خط تیره</StiPenStyleDash>
    <StiPenStyleDashDot>خط چین</StiPenStyleDashDot>
    <StiPenStyleDashDotDot>خط دو نقطه</StiPenStyleDashDotDot>
    <StiPenStyleDot>نقطه</StiPenStyleDot>
    <StiPenStyleDouble>دوگانه</StiPenStyleDouble>
    <StiPenStyleNone>هیچ</StiPenStyleNone>
    <StiPenStyleSolid>تو پر</StiPenStyleSolid>
    <StiPlesseyCheckSumNone>هیچ</StiPlesseyCheckSumNone>
    <StiPreviewModeDotMatrix>ماتریکس نقطه ای</StiPreviewModeDotMatrix>
    <StiPreviewModeStandard>استاندارد</StiPreviewModeStandard>
    <StiPreviewModeStandardAndDotMatrix>استاندارد و ماتریکس نقطه ای</StiPreviewModeStandardAndDotMatrix>
    <StiPrintOnEvenOddPagesTypeIgnore>گذر کردن</StiPrintOnEvenOddPagesTypeIgnore>
    <StiPrintOnEvenOddPagesTypePrintOnEvenPages>چاپ صفحات زوج</StiPrintOnEvenOddPagesTypePrintOnEvenPages>
    <StiPrintOnEvenOddPagesTypePrintOnOddPages>چاپ صفحات فرد</StiPrintOnEvenOddPagesTypePrintOnOddPages>
    <StiPrintOnTypeAllPages>تمام صفحات</StiPrintOnTypeAllPages>
    <StiPrintOnTypeExceptFirstAndLastPage>یه جز خط اول و آخر</StiPrintOnTypeExceptFirstAndLastPage>
    <StiPrintOnTypeExceptFirstPage>یه جز صفحه اول</StiPrintOnTypeExceptFirstPage>
    <StiPrintOnTypeExceptLastPage>یه جز صفحه آخر</StiPrintOnTypeExceptLastPage>
    <StiPrintOnTypeOnlyFirstAndLastPage>فقط صفحه اول و آخر</StiPrintOnTypeOnlyFirstAndLastPage>
    <StiPrintOnTypeOnlyFirstPage>فقط صفحه اول </StiPrintOnTypeOnlyFirstPage>
    <StiPrintOnTypeOnlyLastPage>فقط صفحه آخر</StiPrintOnTypeOnlyLastPage>
    <StiProcessingDuplicatesTypeHide>پنهان</StiProcessingDuplicatesTypeHide>
    <StiProcessingDuplicatesTypeMerge>ادغام</StiProcessingDuplicatesTypeMerge>
    <StiProcessingDuplicatesTypeNone>هیچ</StiProcessingDuplicatesTypeNone>
    <StiReportCacheModeAuto>اتوماتیک</StiReportCacheModeAuto>
    <StiReportCacheModeOff>خاموش</StiReportCacheModeOff>
    <StiReportCacheModeOn>روشن</StiReportCacheModeOn>
    <StiReportUnitTypeCentimeters>سانتیمتر</StiReportUnitTypeCentimeters>
    <StiReportUnitTypeHundredthsOfInch>یک صدم اینچ</StiReportUnitTypeHundredthsOfInch>
    <StiReportUnitTypeInches>اینچ</StiReportUnitTypeInches>
    <StiReportUnitTypeMillimeters>میلیمتر</StiReportUnitTypeMillimeters>
    <StiReportUnitTypePixels>پیکسل</StiReportUnitTypePixels>
    <StiRestrictionsAll>همه</StiRestrictionsAll>
    <StiRestrictionsAllowChange>اجاره تغییر</StiRestrictionsAllowChange>
    <StiRestrictionsAllowDelete>اجاره حذف</StiRestrictionsAllowDelete>
    <StiRestrictionsAllowMove>اجاره حرکت</StiRestrictionsAllowMove>
    <StiRestrictionsAllowResize>اجاره تغییر سایز</StiRestrictionsAllowResize>
    <StiRestrictionsAllowSelect>اجاره انتخاب</StiRestrictionsAllowSelect>
    <StiRestrictionsNone>هیج</StiRestrictionsNone>
    <StiSeriesLabelsValueTypeArgument>آرگومان</StiSeriesLabelsValueTypeArgument>
    <StiSeriesLabelsValueTypeArgumentValue>آرگومان-ارزش</StiSeriesLabelsValueTypeArgumentValue>
    <StiSeriesLabelsValueTypeSeriesTitle>عنوان سری ها</StiSeriesLabelsValueTypeSeriesTitle>
    <StiSeriesLabelsValueTypeSeriesTitleArgument>سری های عنوان -آرگومان</StiSeriesLabelsValueTypeSeriesTitleArgument>
    <StiSeriesLabelsValueTypeSeriesTitleValue>سری های عنوان -ارزش</StiSeriesLabelsValueTypeSeriesTitleValue>
    <StiSeriesLabelsValueTypeValue>ارزش</StiSeriesLabelsValueTypeValue>
    <StiSeriesLabelsValueTypeValueArgument>آرگومان-ارزش</StiSeriesLabelsValueTypeValueArgument>
    <StiSeriesSortDirectionAscending>صعودی</StiSeriesSortDirectionAscending>
    <StiSeriesSortDirectionDescending>نزولی</StiSeriesSortDirectionDescending>
    <StiSeriesSortTypeArgument>آرگومان</StiSeriesSortTypeArgument>
    <StiSeriesSortTypeNone>هیج</StiSeriesSortTypeNone>
    <StiSeriesSortTypeValue>ارزش</StiSeriesSortTypeValue>
    <StiSeriesYAxisLeftYAxis>محورهای چپ Y</StiSeriesYAxisLeftYAxis>
    <StiSeriesYAxisRightYAxis>محورهای راست Y</StiSeriesYAxisRightYAxis>
    <StiShapeDirectionDown>پایین</StiShapeDirectionDown>
    <StiShapeDirectionLeft>چپ</StiShapeDirectionLeft>
    <StiShapeDirectionRight>راست</StiShapeDirectionRight>
    <StiShapeDirectionUp>بالا</StiShapeDirectionUp>
    <StiShiftModeDecreasingSize>اندازه نزولی</StiShiftModeDecreasingSize>
    <StiShiftModeIncreasingSize>اندازه صعودی</StiShiftModeIncreasingSize>
    <StiShiftModeNone>هیچ</StiShiftModeNone>
    <StiShiftModeOnlyInWidthOfComponent>فقط در عرض مولفه</StiShiftModeOnlyInWidthOfComponent>
    <StiSortDirectionAsc>صعودی</StiSortDirectionAsc>
    <StiSortDirectionDesc>نزولی</StiSortDirectionDesc>
    <StiSortDirectionNone>هیچ</StiSortDirectionNone>
    <StiSortTypeByDisplayValue>با نمایش مقدار</StiSortTypeByDisplayValue>
    <StiSortTypeByValue>بوسیله مقدار</StiSortTypeByValue>
    <StiTextHorAlignmentCenter>مرکز</StiTextHorAlignmentCenter>
    <StiTextHorAlignmentLeft>چپ</StiTextHorAlignmentLeft>
    <StiTextHorAlignmentRight>راست</StiTextHorAlignmentRight>
    <StiTextHorAlignmentWidth>عرض</StiTextHorAlignmentWidth>
    <StiTextPositionCenterBottom>پایین مرکز</StiTextPositionCenterBottom>
    <StiTextPositionCenterTop>بالا مرکر</StiTextPositionCenterTop>
    <StiTextPositionLeftBottom>پایین چپ</StiTextPositionLeftBottom>
    <StiTextPositionLeftTop>بالا چپ</StiTextPositionLeftTop>
    <StiTextPositionRightBottom>پایین راست</StiTextPositionRightBottom>
    <StiTextPositionRightTop>بالا راست</StiTextPositionRightTop>
    <StiTextQualityStandard>استاندارد</StiTextQualityStandard>
    <StiTextQualityTypographic>چاپی</StiTextQualityTypographic>
    <StiTextQualityWysiwyg>Wysiwyg</StiTextQualityWysiwyg>
    <StiVertAlignmentBottom>پایین</StiVertAlignmentBottom>
    <StiVertAlignmentCenter>مرکز</StiVertAlignmentCenter>
    <StiVertAlignmentTop>بالا</StiVertAlignmentTop>
    <StiViewModeNormal>عادی</StiViewModeNormal>
    <StiViewModePageBreakPreview>صفحه را در پیش نمایش جدا کنید</StiViewModePageBreakPreview>
    <StringAlignmentCenter>مرکز</StringAlignmentCenter>
    <StringAlignmentFar>دور</StringAlignmentFar>
    <StringAlignmentNear>نزدیک</StringAlignmentNear>
    <StringTrimmingCharacter>کاراکتر</StringTrimmingCharacter>
    <StringTrimmingEllipsisCharacter>حذف کاراکتر</StringTrimmingEllipsisCharacter>
    <StringTrimmingEllipsisPath>حذف مسیر</StringTrimmingEllipsisPath>
    <StringTrimmingEllipsisWord>حذف کلمه</StringTrimmingEllipsisWord>
    <StringTrimmingNone>هیچ</StringTrimmingNone>
    <StringTrimmingWord>کلمه</StringTrimmingWord>
  </PropertyEnum>
  <PropertyEvents>
    <AfterPrintEvent>بعد از چاپ</AfterPrintEvent>
    <AfterSelectEvent>بعد از انتخاب</AfterSelectEvent>
    <BeforePrintEvent>قبل از چاپ</BeforePrintEvent>
    <BeginRenderEvent>شروع ارائه</BeginRenderEvent>
    <CheckedChangedEvent>تغییر چک شده</CheckedChangedEvent>
    <ClickEvent>کلیک</ClickEvent>
    <ClosedFormEvent>فرم بسته شد</ClosedFormEvent>
    <ClosingFormEvent>فرم در حال بسته شدن</ClosingFormEvent>
    <ColumnBeginRenderEvent>ستون شروع ارائه</ColumnBeginRenderEvent>
    <ColumnEndRenderEvent>ستون پایان ارائه</ColumnEndRenderEvent>
    <DoubleClickEvent>دو کلیک</DoubleClickEvent>
    <EndRenderEvent>پایان ارائه</EndRenderEvent>
    <EnterEvent>ورود</EnterEvent>
    <ExportedEvent>صادر شده</ExportedEvent>
    <ExportingEvent>درحال صادرشدن</ExportingEvent>
    <GetArgumentEvent>آرگومان گرفتن</GetArgumentEvent>
    <GetBookmarkEvent>نشانواره را بده</GetBookmarkEvent>
    <GetCrossValueEvent>مقدار تقاطع را بده</GetCrossValueEvent>
    <GetDisplayCrossValueEvent>مقدار نمایش تقاطع را بده</GetDisplayCrossValueEvent>
    <GetExcelSheetEvent>گرفتن صفحه EXCEL</GetExcelSheetEvent>
    <GetExcelValueEvent> Excel گرفتن داده</GetExcelValueEvent>
    <GetHyperlinkEvent>دادن ابر لینک</GetHyperlinkEvent>
    <GetImageDataEvent>گرفتن داده ی تصویری</GetImageDataEvent>
    <GetImageURLEvent> را بده URLتصویر </GetImageURLEvent>
    <GetListOfArgumentsEvent>گرفتن لیست آرگومان ها</GetListOfArgumentsEvent>
    <GetListOfValuesEvent>لیست ارزش ها را بگیر</GetListOfValuesEvent>
    <GetTagEvent>دادن نشانه</GetTagEvent>
    <GetToolTipEvent>نکته ابزار را بده</GetToolTipEvent>
    <GetValueEvent>دادن مقدار</GetValueEvent>
    <LeaveEvent>ترک کردن</LeaveEvent>
    <LoadFormEvent>بارکردن فرم</LoadFormEvent>
    <MouseDownEvent>پایین آمدن موس</MouseDownEvent>
    <MouseEnterEvent>ورود موس</MouseEnterEvent>
    <MouseLeaveEvent>ترک موس</MouseLeaveEvent>
    <MouseMoveEvent>حرکت موس</MouseMoveEvent>
    <MouseUpEvent>بالا آمدن موس</MouseUpEvent>
    <NewAutoSeriesEvent>سری اتوماتیک جدید</NewAutoSeriesEvent>
    <PositionChangedEvent>مکان تییر یافته</PositionChangedEvent>
    <PrintedEvent>پرینت شده</PrintedEvent>
    <PrintingEvent>درحال پرینت</PrintingEvent>
    <ProcessChartEvent>پروسس چارت</ProcessChartEvent>
    <RenderingEvent>در حال ارائه</RenderingEvent>
    <SelectedIndexChangedEvent>تغییر نشانه انتخاب شده</SelectedIndexChangedEvent>
    <StateRestoreEvent>بازیابی حالت</StateRestoreEvent>
    <StateSaveEvent>ذخیره حالت</StateSaveEvent>
    <ValueChangedEvent>مقدار عوض شده</ValueChangedEvent>
  </PropertyEvents>
  <PropertyHatchStyle>
    <BackwardDiagonal>قطری به عقب</BackwardDiagonal>
    <Cross>پیوند</Cross>
    <DarkDownwardDiagonal>قطری به عقب تیره</DarkDownwardDiagonal>
    <DarkHorizontal>افقی تیره</DarkHorizontal>
    <DarkUpwardDiagonal>قطری به طرف بالا تیره</DarkUpwardDiagonal>
    <DarkVertical>عمودی تیره</DarkVertical>
    <DashedDownwardDiagonal>قطری به سمت پایین خط تیره</DashedDownwardDiagonal>
    <DashedHorizontal>افقی خط تیره</DashedHorizontal>
    <DashedUpwardDiagonal>قطری به سمت بالا خط تیره</DashedUpwardDiagonal>
    <DashedVertical>عمودی خط تیره</DashedVertical>
    <DiagonalBrick>قطری گوشه گرد</DiagonalBrick>
    <DiagonalCross>متقاطع قطری</DiagonalCross>
    <Divot>Divot</Divot>
    <DottedDiamond>لوزی نقطه ای</DottedDiamond>
    <DottedGrid>پنجره ای نقطه ای</DottedGrid>
    <ForwardDiagonal>قطری رو به جلو</ForwardDiagonal>
    <Horizontal>افقی</Horizontal>
    <HorizontalBrick>گوشه گرد افقی</HorizontalBrick>
    <LargeCheckerBoard>تخته چک کننده بزرگ</LargeCheckerBoard>
    <LargeConfetti>نقطه ای بزرگ</LargeConfetti>
    <LargeGrid>پنجره ای بزرگ</LargeGrid>
    <LightDownwardDiagonal>قطری رو به پایین روشن</LightDownwardDiagonal>
    <LightHorizontal>افقی روشن</LightHorizontal>
    <LightUpwardDiagonal>قطری رو به بالا روشن</LightUpwardDiagonal>
    <LightVertical>عمودی روشن</LightVertical>
    <NarrowHorizontal>افقی باریک</NarrowHorizontal>
    <NarrowVertical>عمودی باریک</NarrowVertical>
    <OutlinedDiamond>لوزی خلاصه شده</OutlinedDiamond>
    <Percent05>درصد05</Percent05>
    <Percent10>درصد10</Percent10>
    <Percent20>درصد20</Percent20>
    <Percent25>درصد25</Percent25>
    <Percent30>درصد30</Percent30>
    <Percent40>درصد40</Percent40>
    <Percent50>درصد50</Percent50>
    <Percent60>درصد60</Percent60>
    <Percent70>درصد70</Percent70>
    <Percent75>درصد75</Percent75>
    <Percent80>درصد80</Percent80>
    <Percent90>درصد90</Percent90>
    <Plaid>شطرنجی</Plaid>
    <Shingle>پوشاندن</Shingle>
    <SmallCheckerBoard>تخته چک کننده کوچک</SmallCheckerBoard>
    <SmallConfetti>نقلی کوچک</SmallConfetti>
    <SmallGrid>پنجره کوچک</SmallGrid>
    <SolidDiamond>لوزی تو پر</SolidDiamond>
    <Sphere>کروی</Sphere>
    <Trellis>شبکه ای</Trellis>
    <Vertical>عمودی</Vertical>
    <Weave>بافتنی</Weave>
    <WideDownwardDiagonal>قطری رو به پایین پهن</WideDownwardDiagonal>
    <WideUpwardDiagonal>قطری رو به بالا پهن</WideUpwardDiagonal>
    <ZigZag>زیک زاک</ZigZag>
  </PropertyHatchStyle>
  <PropertyMain>
    <AcceptsReturn>بازگشت قبول شد </AcceptsReturn>
    <AcceptsTab>جدول بندی قبول شد</AcceptsTab>
    <AggregateFunction>توابع متراکم</AggregateFunction>
    <AggregateFunctions>توابع متراکم</AggregateFunctions>
    <Alias>نام مستعار</Alias>
    <Alignment>هم ترازی</Alignment>
    <AllowSorting>اجازه مرتب سازی</AllowSorting>
    <AlternatingBackColor>جایگزینی رنگ پیش زمینه</AlternatingBackColor>
    <Angle>زاویه</Angle>
    <Antialiasing>خوشنماسازی</Antialiasing>
    <Area>محیط</Area>
    <Argument>شناسه</Argument>
    <ArgumentDataColumn>ستون داده شناسه</ArgumentDataColumn>
    <ArrowHeight>ارتفاع پیکان</ArrowHeight>
    <ArrowStyle>سبک پیکانی</ArrowStyle>
    <ArrowWidth>عرض پیکان</ArrowWidth>
    <AspectRatio>نسبت جنبی</AspectRatio>
    <Author>مولف</Author>
    <Auto>اتوماتیک</Auto>
    <AutoLocalizeReportOnRun>محلی کردن اتوماتیک  گزارش در حال اجرا </AutoLocalizeReportOnRun>
    <AutoRefresh>تازه شدن اتوماتیک</AutoRefresh>
    <AutoRotate>چرخش اتوماتیک</AutoRotate>
    <AutoScale>انداره گیری اتوماتیک</AutoScale>
    <AutoSeriesColorDataColumn>ستون داده رنگی سری اتوماتیک</AutoSeriesColorDataColumn>
    <AutoSeriesKeyDataColumn>ستون داده کلید سری اتوماتیک</AutoSeriesKeyDataColumn>
    <AutoSeriesTitleDataColumn>ستون داده عنوان سری اتوماتیک</AutoSeriesTitleDataColumn>
    <AutoWidth>عرض اتوماتیک</AutoWidth>
    <AxisValue>محور ارزش ها</AxisValue>
    <BackColor>رنگ پیش</BackColor>
    <Background>زمینه</Background>
    <BackgroundColor>رنگ زمینه</BackgroundColor>
    <BarCodeType>نوع کد میله ای</BarCodeType>
    <Bold>پررنگ</Bold>
    <Bookmark>نشانواره</Bookmark>
    <Border>حاشیه</Border>
    <BorderColor>رنگ حاشیه</BorderColor>
    <Borders>حواشی</Borders>
    <BorderStyle>سبک حاشیه</BorderStyle>
    <Bottom>زیر</Bottom>
    <Brush>قلم</Brush>
    <CacheAllData>ذخیره همه داده ها</CacheAllData>
    <CalcInvisible>Calc پنهان کردن</CalcInvisible>
    <CalculatedDataColumn>ستون داده محاسبه شده</CalculatedDataColumn>
    <CanBreak>توانایی انفصال</CanBreak>
    <Cancel>انصراف</Cancel>
    <CanGrow>توانایی رشد</CanGrow>
    <CanShrink>توانایی جمع شدن</CanShrink>
    <Categories>دسته ها</Categories>
    <Category>دسته</Category>
    <CategoryConnections>ارتباطات</CategoryConnections>
    <CellHeight>ارتفاع سلول</CellHeight>
    <CellWidth>عرض سلول</CellWidth>
    <ChartType>نوع نمودار</ChartType>
    <Checked>چک شده</Checked>
    <CheckOnClick>چک بوسیله کلیک</CheckOnClick>
    <CheckStyle>سبک چک</CheckStyle>
    <CheckStyleForFalse>چک سبک برای اشتباه</CheckStyleForFalse>
    <CheckStyleForTrue>چک سبک برای درست بودن</CheckStyleForTrue>
    <CheckSum>جمع چک</CheckSum>
    <CheckSum1>جمع چک 1</CheckSum1>
    <CheckSum2>جمع چک 2</CheckSum2>
    <Child>فرزند</Child>
    <ChildColumns>ستون های فرزند</ChildColumns>
    <ChildSource>منبع داده فرزند</ChildSource>
    <ClearFormat>قالب را پاک کن</ClearFormat>
    <CloneContainer>تکثیر حامل ها</CloneContainer>
    <Code>کد</Code>
    <Collate>تلفیق</Collate>
    <Color>رنگ</Color>
    <ColorEach>هر رنگ</ColorEach>
    <Column>ستون</Column>
    <ColumnDirection>جهت ستون</ColumnDirection>
    <ColumnGaps>جای خالی ستون</ColumnGaps>
    <ColumnHeadersVisible>نمایش ستون سرصفحه</ColumnHeadersVisible>
    <Columns>ستون ها</Columns>
    <ColumnWidth>عرض ستون</ColumnWidth>
    <CommandTimeout>اتمام وقت اجرا</CommandTimeout>
    <ComponentStyle>سبک مولفه</ComponentStyle>
    <Condition>شرط</Condition>
    <ConditionOptions>انتخاب شرط</ConditionOptions>
    <Conditions>شروط</Conditions>
    <ConnectOnStart>ارتباط شروع</ConnectOnStart>
    <ConstantLines>خطوط ثابت</ConstantLines>
    <Container>حامل</Container>
    <ContourColor>رنگ محدوده</ContourColor>
    <Converting>تبدیل</Converting>
    <ConvertNulls>تبدیل پوچ ها</ConvertNulls>
    <Copies>کپی ها</Copies>
    <CountData>شمارش داده ها </CountData>
    <Create>ایجاد</Create>
    <CreateFieldOnDoubleClick>ایجاد فیلد با دو کلیک</CreateFieldOnDoubleClick>
    <CreateLabel>ساخت برچسب</CreateLabel>
    <CustomFormat>قالب سنتی</CustomFormat>
    <Data>داده</Data>
    <DataAdapter>وفق دهنده</DataAdapter>
    <DataAdapters>وفق دهنده داده</DataAdapters>
    <DataBindings>انقیاد داده</DataBindings>
    <DataColumn>ستون داده</DataColumn>
    <DataField>فیلد داده</DataField>
    <DataRelation>ارتباط داده</DataRelation>
    <DataSource>منبع داده</DataSource>
    <DataSources>منابع داده</DataSources>
    <DataTextField>فیلد متن داده</DataTextField>
    <DataType>نوع داده</DataType>
    <DateInfo>اطلاعات داده</DateInfo>
    <Default>پیش فرض</Default>
    <DefaultNamespace>پیش فرضNamespace</DefaultNamespace>
    <Description>تعاریف</Description>
    <DialogResult>نتیجه مکالکه</DialogResult>
    <Direction>جهت</Direction>
    <DisplayValue>نمایش مقدار</DisplayValue>
    <DistanceBetweenTabs>فاصله ی میان فاصله گدارها</DistanceBetweenTabs>
    <Dock>جاخالی</Dock>
    <DockStyle>سبک جاخالی</DockStyle>
    <DrawBorder>رسم مرز</DrawBorder>
    <DrawLine>کشیدن خط</DrawLine>
    <DropDownAlign>توازن کشش به پایین</DropDownAlign>
    <DropDownStyle>سبک کشش به پایین</DropDownStyle>
    <DropDownWidth>عرض کشش به پایین</DropDownWidth>
    <DropShadow>سایه افتادن</DropShadow>
    <Editable>قابل ویرایش</Editable>
    <EmptyValue>داده ی پوچ</EmptyValue>
    <Enabled>فعال شده</Enabled>
    <EnableLog>ثبت وقایع فعال شده</EnableLog>
    <EncodingType>نوع کدگذاری</EncodingType>
    <EndColor>رنگ انتها</EndColor>
    <EnumeratorSeparator>جداکننده ی شمارنده</EnumeratorSeparator>
    <EnumeratorType>نوع شمارنده</EnumeratorType>
    <EvenStyle>سبک زوج</EvenStyle>
    <ExcelSheet>صفحه excel</ExcelSheet>
    <ExcelValue>Excel مقدار</ExcelValue>
    <ExportAsImage>صادر کردن به عنوان عکس</ExportAsImage>
    <Expression>عبارت</Expression>
    <FaqPage>Faq صفحه</FaqPage>
    <FieldIs>فیلد است</FieldIs>
    <File>فایل</File>
    <Filter>فیلتر</Filter>
    <FilterOn>روشن شدن</FilterOn>
    <Filters>فیلترها</Filters>
    <FirstTabOffset>تعادل فاصله گدار اول</FirstTabOffset>
    <Flat>یک سطح</Flat>
    <FlatMode>حالت یک سطح</FlatMode>
    <Focus>متمرکز شدن</Focus>
    <Font>فونت</Font>
    <FontBold>فونت پررنگ</FontBold>
    <FontItalic>فونت حروف کج</FontItalic>
    <FontName>نام فونت</FontName>
    <FontSize>سایز فونت</FontSize>
    <FontStrikeout>فونت باطل شدن</FontStrikeout>
    <FontSubscript>زیرنویس</FontSubscript>
    <FontSuperscript>بالا نویس</FontSuperscript>
    <FontUnderline>فونت خط زیر</FontUnderline>
    <FontUnit>واحد فونت</FontUnit>
    <ForeColor>رنگ جلو</ForeColor>
    <Format>قالب</Format>
    <FullConvertExpression>عبارت تمام تبدیل شده</FullConvertExpression>
    <Function>تابع</Function>
    <Functions>توابع</Functions>
    <GlobalizationStrings>رشته های عمومی شده</GlobalizationStrings>
    <GlobalizedName>نام عمومی</GlobalizedName>
    <GridLineColor>رنگ خط پنجره</GridLineColor>
    <GridLinesHor>خطوط پنجره افقی</GridLinesHor>
    <GridLinesHorRight>خطوط بهم پیچیده ی راست افقی</GridLinesHorRight>
    <GridLineStyle>سبک خط پنجره</GridLineStyle>
    <GridLinesVert>خطوط پنجره عمودی</GridLinesVert>
    <GrowToHeight>افزایش تا ارتفاع</GrowToHeight>
    <HeaderBackColor>رنگ پشت سرصفحه</HeaderBackColor>
    <HeaderFont>فونت سرصفحه</HeaderFont>
    <HeaderForeColor>رنگ جلو سرصفحه</HeaderForeColor>
    <HeaderText>متن سرصفحه</HeaderText>
    <Height>ارتفاع</Height>
    <HideZeros>پنهان سازی صفرها</HideZeros>
    <High>ارتفاع</High>
    <HighlightCondition>جلوه سازی شرط</HighlightCondition>
    <HorAlignment>توازن افقی</HorAlignment>
    <HorSpacing>فضای افقی</HorSpacing>
    <HotkeyPrefix>Hotkey پیشوند</HotkeyPrefix>
    <Hyperlink>ابرلینک</Hyperlink>
    <Idents>مشخصه ها</Idents>
    <Image>تصویر</Image>
    <ImageAlignment>تنظیم تصویر</ImageAlignment>
    <ImageData>داده ی تصویری</ImageData>
    <ImageMultipleFactor>فاکتورهای چندگانه ی تصویری</ImageMultipleFactor>
    <ImageStretch>ارتجاع تصویر</ImageStretch>
    <ImageTiling>تصویر کاشی شده</ImageTiling>
    <ImageTransparency>شفافیت تصویر</ImageTransparency>
    <ImageURL>تصویر URL</ImageURL>
    <ImportRelations>ورود ارتباطات</ImportRelations>
    <Increment>افزایش</Increment>
    <Indent>تورفتگی</Indent>
    <Insert>الحاق</Insert>
    <InterlacedBrush>قلموی بافته شده</InterlacedBrush>
    <InterlacingHor>بافته شده افقی</InterlacingHor>
    <InterlacingVert>بافته شده عمودی</InterlacingVert>
    <Italic>خط کج</Italic>
    <Item>مورد</Item>
    <ItemHeight>ارتفاع مورد</ItemHeight>
    <Items>موارد</Items>
    <KeepChildTogether>نگه داشتن فرزند ها با هم</KeepChildTogether>
    <KeepFooterTogether>نگه داشتن زیرنویس با هم</KeepFooterTogether>
    <KeepGroupTogether>نگه داشتن گروه با هم</KeepGroupTogether>
    <KeepHeaderTogether>نگه داشتن سرصفحه با هم</KeepHeaderTogether>
    <KeyDataColumn>کلید ستون داده</KeyDataColumn>
    <LabelColor>برچسب رنگ</LabelColor>
    <Labels>برچسب ها</Labels>
    <LabelsColor>رنگ برچسب ها</LabelsColor>
    <LabelsOffset>یرچسب های افست</LabelsOffset>
    <Language>زبان</Language>
    <LargeHeight>ارتفاع وسیع</LargeHeight>
    <LargeHeightFactor>فاکتور ارتفاع بزرگ</LargeHeightFactor>
    <Left>چپ</Left>
    <Legend>فهرست علایم</Legend>
    <LegendValueType>نوع داده فهرست</LegendValueType>
    <Length>درازا</Length>
    <Lighting>نورپردازی</Lighting>
    <LineColor>رنگ خط</LineColor>
    <LineLimit>محدود کردن خط</LineLimit>
    <LinesOfUnderline>خطوط زیرخط سازی</LinesOfUnderline>
    <LineStyle>سبک خط</LineStyle>
    <LineWidth>عرض خط</LineWidth>
    <Linked>مرتبط شده</Linked>
    <ListOfArguments>لیست شناسه ها</ListOfArguments>
    <ListOfValues>لیست مقادیر</ListOfValues>
    <Localizable>محلی سازی</Localizable>
    <Location>مکان</Location>
    <Locked>قفل شده</Locked>
    <Low>پایین</Low>
    <Margins>حواشی</Margins>
    <MarkerAlignment>توازن نشانه گذارها</MarkerAlignment>
    <MarkerColor>رنگ نشانه گذار</MarkerColor>
    <MarkerSize>سایزنشانه گذار</MarkerSize>
    <MarkerType>نوع نشانه کدار</MarkerType>
    <MarkerVisible>مشاهده نشانه گذارها</MarkerVisible>
    <MasterComponent>مولفه اصلی</MasterComponent>
    <MasterKeyDataColumn>ستون داده  کلید اصلی</MasterKeyDataColumn>
    <MatrixSize>سایز ماتریکس</MatrixSize>
    <MaxDate>تاریخ بیشینخ</MaxDate>
    <MaxDropDownItems>بیشترین موارد کشش به پایین</MaxDropDownItems>
    <Maximum>بیشینه</Maximum>
    <MaxLength>بیشترین طول</MaxLength>
    <MaxNumberOfLines>بیشینه اعداد خطوط</MaxNumberOfLines>
    <MaxSize>سایز بیشینه</MaxSize>
    <MaxValue>بیشترین مقدار</MaxValue>
    <MergeDuplicates>ادغام تکراری</MergeDuplicates>
    <MinDate>تاریخ کمینه</MinDate>
    <Minimum>کمینه</Minimum>
    <MinimumFontSize>کمترین اندازه فونت</MinimumFontSize>
    <MinorColor>رنگ کم</MinorColor>
    <MinorCount>شمارش کم</MinorCount>
    <MinorLength>طول کم</MinorLength>
    <MinorStyle>سبک کم</MinorStyle>
    <MinorVisible>مشاهده کم</MinorVisible>
    <MinRowsInColumn>کمترین ردیف ها در ستون</MinRowsInColumn>
    <MinSize>کمترین اندازه</MinSize>
    <MinValue>کمترین مقدار</MinValue>
    <Module>ماژول</Module>
    <Move>حرکت</Move>
    <Multiline>چند خطی</Multiline>
    <MultipleFactor>فاکتور چندتایی</MultipleFactor>
    <Name>نام</Name>
    <NameInSource>نام در منبع</NameInSource>
    <NameParent>نام والد</NameParent>
    <Namespaces>فضا نام</Namespaces>
    <NextPage>صفحه بعد</NextPage>
    <NullText>متن پوچ</NullText>
    <NumberOfColumns>عدد ستون ها</NumberOfColumns>
    <NumberOfCopies>تعداد کپی ها</NumberOfCopies>
    <NumberOfPass>تعداد گدرها</NumberOfPass>
    <OddStyle>سبک فرد</OddStyle>
    <OnlyText>فقط متن</OnlyText>
    <Options>انتخاب</Options>
    <Orientation>جهت یابی</Orientation>
    <PageHeight>ارتفاع صفحه</PageHeight>
    <PageNumbers>شماره های صفخه</PageNumbers>
    <PageWidth>عرض صفحه</PageWidth>
    <Paper>صفحه</Paper>
    <PaperSize>سایز کاغذ</PaperSize>
    <Parameter>پارامتر</Parameter>
    <Parameters>پارامترها</Parameters>
    <ParentColumns>ستون های والد</ParentColumns>
    <ParentSource>منبع داده والد</ParentSource>
    <ParentValue>ارزش والد</ParentValue>
    <PasswordChar>کارکتر کلمه رمز</PasswordChar>
    <Placement>قراردادن</Placement>
    <PlaceOnToolbox>جایگذاری با جعبه ابزار</PlaceOnToolbox>
    <PointAtCenter>نقطه در مرکز</PointAtCenter>
    <Position>موقعیت</Position>
    <PreferredColumnWidth>عرض ستون ترجیح داده شده</PreferredColumnWidth>
    <PreferredRowHeight>ارتفاع ستون ترجیح داده شده</PreferredRowHeight>
    <PreviewMode>حالت پیش نمایش</PreviewMode>
    <PreviewSettings>تنظیمات یش نمایش</PreviewSettings>
    <Printable>قابل چاپ</Printable>
    <PrintAtBottom>در پایین چاپ کن</PrintAtBottom>
    <PrinterName>نام پرینتر</PrinterName>
    <PrinterSettings>تنظیمات پرینتر</PrinterSettings>
    <PrintHeadersFootersFromPreviousPage>سربرگ و پانوشت را ازصفحه ی قبل پرینت بگیر </PrintHeadersFootersFromPreviousPage>
    <PrintIfDetailEmpty>چاپ کن اگر جزییات خالی است</PrintIfDetailEmpty>
    <PrintIfEmpty>چاپ اگر خالی</PrintIfEmpty>
    <PrintOn>پرینت برروی</PrintOn>
    <PrintOnAllPages>چاپ در همه ی صفحه ها</PrintOnAllPages>
    <PrintOnEvenOddPages>چاپ در صفحه های زوج فرد</PrintOnEvenOddPages>
    <PrintOnPreviousPage>چاپ در صفحه قبل</PrintOnPreviousPage>
    <ProcessAtEnd>پردازش تا انتها</ProcessAtEnd>
    <ProcessingDuplicates>پردازش دو نسخه ای</ProcessingDuplicates>
    <ProductHomePage>تولید صفحه خانگی</ProductHomePage>
    <Range>برد</Range>
    <Ratio>نسبت</Ratio>
    <ReadOnly>فقط خواندنی</ReadOnly>
    <ReconnectOnEachRow>ارتباط دوباره در هر ردیف</ReconnectOnEachRow>
    <ReferencedAssemblies>اسمبلی ارجاع داده شده</ReferencedAssemblies>
    <Refresh>دباره نو شدن</Refresh>
    <Relation>ارتباط</Relation>
    <RelationName>نام ارتباط</RelationName>
    <Relations>ارتباطات</Relations>
    <RemoveUnusedDataBeforeStart>حذف داده های غیر قابل استفاده قبل از شروع</RemoveUnusedDataBeforeStart>
    <RenderTo>ارائه به</RenderTo>
    <ReportAlias>گزارش مستعار</ReportAlias>
    <ReportAuthor>مولف گزارش</ReportAuthor>
    <ReportCacheMode>گزارش حالت پنهان</ReportCacheMode>
    <ReportDescription>تعریف گزارش</ReportDescription>
    <ReportName>نام گزارش</ReportName>
    <ReportUnit>واحد گزارش</ReportUnit>
    <ResetDataSource>پاک کردن منبع داده</ResetDataSource>
    <ResetPageNumber>پاک کردن شماره صفحه</ResetPageNumber>
    <Resize>دوباره اندازه گیری</Resize>
    <Restrictions>محدودیت ها</Restrictions>
    <ReturnValue>مقدار بارگشتی</ReturnValue>
    <ReverseHor>معکوس افقی</ReverseHor>
    <ReverseVert>معکوس عمودی</ReverseVert>
    <Right>راست</Right>
    <RightToLeft>راست به چپ</RightToLeft>
    <Round>گرد کردن</Round>
    <RowHeadersVisible>نمایش سرصفحه ردیف</RowHeadersVisible>
    <RowHeaderWidth>عرض سرصفحه ردیف</RowHeaderWidth>
    <Scale>برد</Scale>
    <ScaleHor>برد افقی</ScaleHor>
    <ScriptLanguage>زبان متن سند</ScriptLanguage>
    <SegmentPerHeight>ارتفاع هر قسمت</SegmentPerHeight>
    <SegmentPerWidth>عرض هر قسمت</SegmentPerWidth>
    <SelectedIndex>ایندکس انتخاب شده</SelectedIndex>
    <SelectedItem>مورد انتخاب شده</SelectedItem>
    <SelectedValue>مقدار انتخاب شده</SelectedValue>
    <SelectionBackColor>انتخاب رنگ پشتی</SelectionBackColor>
    <SelectionForeColor>انتخاب رنگ جلویی</SelectionForeColor>
    <SelectionMode>حالت انتخاب</SelectionMode>
    <Series>سری ها</Series>
    <SeriesLabels>برچسب های سری ها</SeriesLabels>
    <Shadow>سایه</Shadow>
    <ShadowBrush>قلم سایه</ShadowBrush>
    <ShadowSize>سایز سایه</ShadowSize>
    <ShapeType>نوع شکل</ShapeType>
    <Shift>انتقال</Shift>
    <ShiftMode>حالت انتقال</ShiftMode>
    <ShowBehind>نمایش پشت</ShowBehind>
    <ShowDialog>نمایش دیالوگ</ShowDialog>
    <ShowEdgeValues>نمایش ارزش های لبه</ShowEdgeValues>
    <ShowImageBehind>نمایش تصویر پشتی</ShowImageBehind>
    <ShowInLegend>نمایش در فهرست علایم</ShowInLegend>
    <ShowInPercent>نمایش به درصد</ShowInPercent>
    <ShowLabels>نمایش برچسب ها</ShowLabels>
    <ShowLabelText>نمایش متن برچسب</ShowLabelText>
    <ShowMarker>نمایش نشان گذار</ShowMarker>
    <ShowOnZeroValues>نمایش مقادیرروی صفر</ShowOnZeroValues>
    <ShowShadow>نمایش سایه</ShowShadow>
    <ShowTotal>نمایش جمع</ShowTotal>
    <ShowUpDown>نمایش بالا به پایین</ShowUpDown>
    <ShowValue>نمایش ارزش</ShowValue>
    <ShowZeros>نمایش صفرها</ShowZeros>
    <ShrinkFontToFit>انقباض متن تا قسمت مناسب</ShrinkFontToFit>
    <ShrinkFontToFitMinimumSize>انقباض متن تا اندازه ی کمینه مناسب</ShrinkFontToFitMinimumSize>
    <Side>طرف</Side>
    <Size>سایز</Size>
    <SizeMode>حالت سایز</SizeMode>
    <Smoothing>هموارسازی</Smoothing>
    <Sort>مرتب کردن</Sort>
    <SortBy>مرتب سازی با</SortBy>
    <SortDirection>مرتب سازی جهت</SortDirection>
    <Sorted>مرتب شده</Sorted>
    <SortType>نوع مرتب سازی</SortType>
    <Space>فضای خالی</Space>
    <Spacing>فضا سازی</Spacing>
    <SqlCommand>Sql دستور</SqlCommand>
    <StartAngle>نمایش زاویه</StartAngle>
    <StartColor>رنگ شروع</StartColor>
    <StartFromZero>شروع از صفر</StartFromZero>
    <StartMode>حالت شروع</StartMode>
    <StartNewPage>شروع صفحه جدید</StartNewPage>
    <StartNewPageIfLessThan>صفحه جدید را شروع کن اگر کمتر از</StartNewPageIfLessThan>
    <StartPosition>مکان شروع</StartPosition>
    <Step>پبه</Step>
    <Stop>توقف</Stop>
    <StopBeforePage>توقف قبل از صفحه</StopBeforePage>
    <StopBeforePrint>توقف قبل از چاپ</StopBeforePrint>
    <Stretch>کشش</Stretch>
    <StretchToPrintArea>کشش به محوطه چاپ</StretchToPrintArea>
    <StripBrush>برس باریک</StripBrush>
    <Strips>نوارها</Strips>
    <Style>سبک</Style>
    <Styles>سبک ها</Styles>
    <SubReportPage>صفحه زیر گزارش</SubReportPage>
    <Summary>خلاصه</Summary>
    <SystemVariable>متغیر سیستم</SystemVariable>
    <SystemVariables>متغیرهای سیستم</SystemVariables>
    <Tag>برچسب</Tag>
    <TagValue>مقدار برچسب</TagValue>
    <Tension>کشش</Tension>
    <Text>متن</Text>
    <TextAfter>متن بعد از</TextAfter>
    <TextAlign>توازن متن</TextAlign>
    <TextBefore>متن قبل از</TextBefore>
    <TextBrush>قلم متن</TextBrush>
    <TextColor>رنگ متن</TextColor>
    <TextFormat>قالب متن</TextFormat>
    <TextOnly>فقط متن</TextOnly>
    <TextOptions>انتخاب متن</TextOptions>
    <TextQuality>کیفیت متن</TextQuality>
    <Ticks>تیک ها</Ticks>
    <Title>عنوان</Title>
    <TitleBeforeHeader>عنوان قبل از سرصفحه</TitleBeforeHeader>
    <TitleColor>رنگ عنوان</TitleColor>
    <TitleFont>فونت عنوان</TitleFont>
    <TitleVisible>مریی</TitleVisible>
    <Today>امروز</Today>
    <ToolTip>تیپ ابزار</ToolTip>
    <Top>بالا</Top>
    <Total>جمع</Total>
    <Totals>مچموع</Totals>
    <TransparentColor>رنگ شفاف</TransparentColor>
    <Trimming>مرتب کردن</Trimming>
    <Type>نوع</Type>
    <TypeName>نام نوع</TypeName>
    <Types>انواع</Types>
    <Underline>خط زیر</Underline>
    <UndoLimit>بازگرداندن محدودیت</UndoLimit>
    <Unit>واحد</Unit>
    <UnlimitedBreakable>جداسازی نامحدود</UnlimitedBreakable>
    <UnlimitedHeight>ارتفاع نامحدود</UnlimitedHeight>
    <UnlimitedWidth>عرض نامحدود</UnlimitedWidth>
    <UseAliases>استفاده از نام مستعار</UseAliases>
    <UseRectangularSymbols>استفاده از نماد مستطیلی</UseRectangularSymbols>
    <UseSeriesColor>استفاره از رنگ سری ها</UseSeriesColor>
    <UseStyleOfSummaryInColumnTotal>استفاده از شیوه ی خلاصه در ستون جمع</UseStyleOfSummaryInColumnTotal>
    <UseStyleOfSummaryInRowTotal>استفاده از شیوه ی خلاصه در ردیف جمع</UseStyleOfSummaryInRowTotal>
    <Value>مقدار</Value>
    <ValueDataColumn>مقدار ستون داده</ValueDataColumn>
    <ValueType>نوع داده</ValueType>
    <Variable>متغیر</Variable>
    <Variables>متغیرها</Variables>
    <Version>نسخه</Version>
    <VertAlignment>توازن عمودی</VertAlignment>
    <VertSpacing>فضای عمودی</VertSpacing>
    <ViewMode>حالت دید</ViewMode>
    <Visible>قابل مشاهده</Visible>
    <Watermark>سایه دار کردن</Watermark>
    <Width>عرض</Width>
    <WindowState>حالت پنجره</WindowState>
    <WordWrap>پنهان سازی کلمه</WordWrap>
    <Wrap>پنهان ساری</Wrap>
    <WrapGap>جای خالی پنهان</WrapGap>
    <XAxis>X محور</XAxis>
    <XTopAxis>X محور بالا</XTopAxis>
    <YAxis>Y محور</YAxis>
    <YRightAxis>Y محور راست</YRightAxis>
    <Zoom>زوم</Zoom>
  </PropertyMain>
  <PropertySystemColors>
    <ActiveBorder>فعال کردن حاشیه</ActiveBorder>
    <ActiveCaption>فعال کردن عنوان</ActiveCaption>
    <ActiveCaptionText>فعال کردن متن عنوان</ActiveCaptionText>
    <AppWorkspace>فضای کاری برنامه</AppWorkspace>
    <Control>کنترل</Control>
    <ControlDark>کنترل تیره</ControlDark>
    <ControlDarkDark>کنترل تیره تیره</ControlDarkDark>
    <ControlLight>کنترل روشن</ControlLight>
    <ControlLightLight>کنترل روشن روشن</ControlLightLight>
    <ControlText>متن کنترل</ControlText>
    <Desktop>میز کار</Desktop>
    <GrayText>متن خاکستری</GrayText>
    <Highlight>جلوه دادن</Highlight>
    <HighlightText>جلوه دادن متن</HighlightText>
    <HotTrack>شیار تند</HotTrack>
    <InactiveBorder>حاشیه غیر فعال</InactiveBorder>
    <InactiveCaption>عنوان غیر فعال</InactiveCaption>
    <InactiveCaptionText>متن عنوان غیرفعال</InactiveCaptionText>
    <Info>اطلاعات</Info>
    <InfoText>متن اطلاعات</InfoText>
    <Menu>منو</Menu>
    <MenuText>متن منو</MenuText>
    <ScrollBar>نوار طومار</ScrollBar>
    <Window>پنجره</Window>
    <WindowFrame>قاب پنجره</WindowFrame>
    <WindowText>متن پنجره</WindowText>
  </PropertySystemColors>
  <QueryBuilder>
    <AddObject>اضافه کردن شی</AddObject>
    <AddSubQuery>اضافه کردن جدول مشتق شده</AddSubQuery>
    <AllObjects>(همه ی اشیا)</AllObjects>
    <BadFromObjectExpression>باطل شده از تعریف شی!</BadFromObjectExpression>
    <BadObjectName>باطل شده از نام شی!</BadObjectName>
    <BadSelectStatement>دستور انتخابی باطل شده!</BadSelectStatement>
    <CreateLinksFromForeignKeys>Create Links from Foreign Keys</CreateLinksFromForeignKeys>
    <CriteriaAlias>نام مستعار</CriteriaAlias>
    <CriteriaCriteria>ضایطه</CriteriaCriteria>
    <CriteriaExpression>تعریف</CriteriaExpression>
    <CriteriaGroupBy>گروه بوسیله</CriteriaGroupBy>
    <CriteriaOr>یا...</CriteriaOr>
    <CriteriaOutput>خروجی</CriteriaOutput>
    <CriteriaSortOrder>جهت مرتب سازی </CriteriaSortOrder>
    <CriteriaSortType> نوع مرتب سازی</CriteriaSortType>
    <Database>پایگاه داده</Database>
    <DataSourceProperties>خصوصیات منبع داده</DataSourceProperties>
    <DialectDontSupportDatabases>سرور درخواست هایی با اشیا از دیتابیس های مختلف را جوابگو نیست.</DialectDontSupportDatabases>
    <DialectDontSupportSchemas>سرور مدل را پشتیبانی نمی کند.</DialectDontSupportSchemas>
    <DialectDontSupportUnions>سرور اتحاد را پشتیبانی نمی کند</DialectDontSupportUnions>
    <DialectDontSupportUnionsBrackets>سرور براکت در اتحاد را پشتیبانی نمی کند.</DialectDontSupportUnionsBrackets>
    <DialectDontSupportUnionsBracketsInSubQuery>سرور براکت در اتحاد  در زیر درخواست ها را پشتیبانی نمی کند</DialectDontSupportUnionsBracketsInSubQuery>
    <DialectDontSupportUnionsInSubQueries>سرور  اتحاد  در زیر درخواست ها را پشتیبانی نمی کند</DialectDontSupportUnionsInSubQueries>
    <Edit>ویرایش</Edit>
    <EncloseWithBrackets>دربر گرفتن با براکت</EncloseWithBrackets>
    <Expressions>بیان</Expressions>
    <InsertEmptyItem>ورود مورد خالی</InsertEmptyItem>
    <JoinExpression>بیان پیوند</JoinExpression>
    <LabelAlias>نام مستعار:</LabelAlias>
    <LabelFilterObjectsBySchemaName>اشیا فیلتر شده بوسیله ی نام مدل:</LabelFilterObjectsBySchemaName>
    <LabelJoinExpression>یان پیوند:</LabelJoinExpression>
    <LabelLeftColumn>ستون چپ:</LabelLeftColumn>
    <LabelLeftObject>شی چپ:</LabelLeftObject>
    <LabelObject>شی:</LabelObject>
    <LabelRightColumn>ستون راست:</LabelRightColumn>
    <LabelRightObject>شی راست:</LabelRightObject>
    <LinkProperties>خصوصیات رابط</LinkProperties>
    <MetadataProviderCantExecSQL>تولبد کننده ی فرا داده نمی تواند درخواست  اس کبو ال را اجراکتد</MetadataProviderCantExecSQL>
    <MetaProviderCantLoadMetadata>.تولبد کننده ی فرا داده نمی تواند فراداده را اتوماتیک بار گداری کند</MetaProviderCantLoadMetadata>
    <MetaProviderCantLoadMetadataForDatabase>: {0}تولبد کننده ی فرا داده نمی تواند فراداده را برای پاتگاه داده اتوماتیک بار گداری کند </MetaProviderCantLoadMetadataForDatabase>
    <MoveDown>حرکت به پایین</MoveDown>
    <MoveUp>حرکت به بالا</MoveUp>
    <NewUnionSubQuery>زیر درخواست اتحاد جدید</NewUnionSubQuery>
    <NoConnectionObject>هیچ شی ارتباطی (property {0} not assigned).</NoConnectionObject>
    <NoTransactionObject>هیچ شی تراکنشی (property {0} not assigned).</NoTransactionObject>
    <Objects>اشیا</Objects>
    <ProcedureParameters>پارامترهای رویه</ProcedureParameters>
    <Procedures>رویه ها</Procedures>
    <qnSaveChanges>شما می خواهید تغییرات درخواست ذخیره شود?</qnSaveChanges>
    <Query>درخواست</Query>
    <QueryBuilder>سازنده درخواست</QueryBuilder>
    <QueryParameters>خصوصیات پارامترها</QueryParameters>
    <QueryProperties> خصوصیات درخواست</QueryProperties>
    <Remove>حذف</Remove>
    <RemoveBrackets>حذف براکت</RemoveBrackets>
    <RunQueryBuilder>اجرای سازنده ی درخواست</RunQueryBuilder>
    <SelectAllFromLeft>انتخاب همه از چپ</SelectAllFromLeft>
    <SelectAllFromRight>انتخاب همه از راست</SelectAllFromRight>
    <SwitchToDerivedTable>سوییچ به جدول تحویلی</SwitchToDerivedTable>
    <Tables>جدول ها</Tables>
    <UnexpectedTokenAt>علامت غیرمنتظره \"{0}\" در خط {1}, پست {2}!</UnexpectedTokenAt>
    <Unions>اتحادها</Unions>
    <UnionSubMenu>اتحاد</UnionSubMenu>
    <ViewQuery>درخواست از دید</ViewQuery>
    <Views>دید</Views>
  </QueryBuilder>
  <Questions>
    <qnDictionaryNew>آیا می خواهید دیکشنری جدید ایجاد کنید؟</qnDictionaryNew>
    <qnLanguageNew>شما زبان گزارش را تغییر دادید.این منتهی به تولید کد گزارش جدید می شود.ایا شما مطمئنید که میخواهید زبان جدید را ذخیره کنید؟</qnLanguageNew>
    <qnPageDelete>آیا می خواهید صفحه را حذف کنید؟</qnPageDelete>
    <qnRemove>آیا میخواهید صفحه را پاک کنید؟</qnRemove>
    <qnRemoveService>آیا میخواهید سرویس را پاک کنید؟</qnRemoveService>
    <qnRemoveServiceCategory>آیا میخواهید دسته را پاک کنید؟</qnRemoveServiceCategory>
    <qnRemoveUnused>آیا میخواهید استفاده نشده ها را پاک کنید؟</qnRemoveUnused>
    <qnRestoreDefault>بازیابی پیش فرض ها؟</qnRestoreDefault>
    <qnSaveChanges>ذخیره تغییرات در {0}?</qnSaveChanges>
    <qnSaveChangesToPreviewPage>آیا می خواهید تغییرت صفحه را ذخیره کنید؟</qnSaveChangesToPreviewPage>
    <qnSynchronize>محتویات انبار داده و محتویات دیکشنری را همسان می کنید؟</qnSynchronize>
    <qnSynchronizeServices>سرویس ها همزمان شوند؟</qnSynchronizeServices>
  </Questions>
  <Report>
    <Bands>مرزها</Bands>
    <Charts>نمودارها</Charts>
    <CollapseAll>خراب کردن همه</CollapseAll>
    <CompilingReport>در حال کامپایل شدن</CompilingReport>
    <Components>مولفات</Components>
    <ConnectingToData>در حال ارتباط داده</ConnectingToData>
    <CreatingReport>در حال خلق گزارش</CreatingReport>
    <CrossBands>پیوند نوار)مرز( ها</CrossBands>
    <Dialogs>کنترل های گزارش</Dialogs>
    <EditStyles>[ویرایش سبک ها]</EditStyles>
    <EventsTab>برچسب وقایع</EventsTab>
    <ExpandAll>گسترش همه</ExpandAll>
    <FilterAnd>و</FilterAnd>
    <FilterOr>یا</FilterOr>
    <FinishingReport>در حال اتمام گزارش</FinishingReport>
    <FirstPass>اولین گذر</FirstPass>
    <GenerateNewCode>کد جدید را تولید کنید</GenerateNewCode>
    <LabelAlias>نام مستعار:</LabelAlias>
    <LabelAuthor>مولف:</LabelAuthor>
    <LabelBackground>پیش زمینه:</LabelBackground>
    <LabelCategory>دسته بندی:</LabelCategory>
    <LabelCentimeters>سانتی متر:</LabelCentimeters>
    <LabelColor>رنگ:</LabelColor>
    <LabelCountData>شمارش داده:</LabelCountData>
    <LabelDataBand>متحد کردن داده:</LabelDataBand>
    <LabelDataColumn>ستون دیتا</LabelDataColumn>
    <LabelDefaultValue>مقدار پیش فرض:</LabelDefaultValue>
    <LabelExpression>عیارت:</LabelExpression>
    <LabelFontName>نام فونت:</LabelFontName>
    <LabelFunction>تابع:</LabelFunction>
    <LabelHundredthsOfInch>یک صدم اینچ:</LabelHundredthsOfInch>
    <LabelInches>اینچ:</LabelInches>
    <LabelMillimeters>میلیمتر:</LabelMillimeters>
    <LabelName>نام:</LabelName>
    <LabelNameInSource>نام در منیع:</LabelNameInSource>
    <LabelPassword>رمز:</LabelPassword>
    <LabelPixels>پیکسل:</LabelPixels>
    <LabelSystemVariable>متغیر سیستم:</LabelSystemVariable>
    <LabelTotals>مجموع</LabelTotals>
    <LabelType>تایپ:</LabelType>
    <LabelUserName>نام کاربری:</LabelUserName>
    <LabelValue>ارزش:</LabelValue>
    <LoadingReport>یارگذاری گزارش</LoadingReport>
    <nameAssembly>اسمبلی</nameAssembly>
    <No>نه</No>
    <NotAssigned>انتساب داده نشده</NotAssigned>
    <PageNofM>صفحه {0} از {1}</PageNofM>
    <PreparingReport>آماده کردن گزارش</PreparingReport>
    <PropertiesTab>برچسب خصوصیات</PropertiesTab>
    <RangeAll>همه</RangeAll>
    <RangeCurrentPage>صفحه جاری</RangeCurrentPage>
    <RangeInfo>شماره صفحه و/یا محدوده صفحات که بوسیله کاما جدا شدهرا وارد کنید.برای مثال 1و3و5-12</RangeInfo>
    <RangePage>برد صفحه</RangePage>
    <RangePages>صفحات:</RangePages>
    <SavingReport>ذخیره سازی گزارش</SavingReport>
    <SecondPass>دومین گذر</SecondPass>
    <StiEmptyBrush>خالی</StiEmptyBrush>
    <StiGlareBrush>درخشش</StiGlareBrush>
    <StiGradientBrush>متحرک</StiGradientBrush>
    <StiHatchBrush>هاشور زدن</StiHatchBrush>
    <StiSolidBrush>توپر</StiSolidBrush>
    <StyleBad>ید</StyleBad>
    <StyleGood>خوب</StyleGood>
    <StyleNeutral>هسته ای</StyleNeutral>
    <StyleNormal>نرمال</StyleNormal>
    <StyleNote>یادداشت</StyleNote>
    <StyleWarning>اخطار</StyleWarning>
  </Report>
  <Services>
    <categoryContextTools>ابزار متن</categoryContextTools>
    <categoryDesigner>طراح</categoryDesigner>
    <categoryDictionary>دیکشنری</categoryDictionary>
    <categoryExport>صادرات</categoryExport>
    <categoryLanguages>زبان ها</categoryLanguages>
    <categoryPanels>تابلو</categoryPanels>
    <categoryRender>ارائه</categoryRender>
    <categoryShapes>پیکرها</categoryShapes>
    <categorySL>ذخیره یا بارکردن</categorySL>
    <categorySystem>سیستم</categorySystem>
    <categoryTextFormat>قالب متن</categoryTextFormat>
  </Services>
  <Shapes>
    <Arrow>پیکان</Arrow>
    <DiagonalDownLine>خط قطری پایین</DiagonalDownLine>
    <DiagonalUpLine>خط قطری بالا</DiagonalUpLine>
    <HorizontalLine>خط افقی</HorizontalLine>
    <LeftAndRightLine>خط راست و چپ</LeftAndRightLine>
    <Oval>بیضی</Oval>
    <Rectangle>مستطیل</Rectangle>
    <RoundedRectangle>مستطیل خمیده شده</RoundedRectangle>
    <ServiceCategory>پیکرها</ServiceCategory>
    <TopAndBottomLine>خط پایین به بالا</TopAndBottomLine>
    <Triangle>مثلث</Triangle>
    <VerticalLine>خط عمودی</VerticalLine>
  </Shapes>
  <Toolbars>
    <Align>تنظیم</Align>
    <AlignBottom>توازن پایینی</AlignBottom>
    <AlignCenter>توازن مرکزی</AlignCenter>
    <AlignLeft>توازن چپ</AlignLeft>
    <AlignMiddle>توازن میانی</AlignMiddle>
    <AlignRight>توازن راست</AlignRight>
    <AlignToGrid>توازن با پنچره</AlignToGrid>
    <AlignTop>توازن بالا</AlignTop>
    <AlignWidth>شایسته</AlignWidth>
    <BringToFront>بیار به جلو</BringToFront>
    <CenterHorizontally>تمرکز افقی</CenterHorizontally>
    <CenterVertically>تمرکز عمودی</CenterVertically>
    <Conditions>شرایط</Conditions>
    <FontName>نام قالب</FontName>
    <FontSize>اندازه فونت</FontSize>
    <FontStyleBold>سبک فونت پررنگ</FontStyleBold>
    <FontStyleItalic>سبک فونت کج</FontStyleItalic>
    <FontStyleUnderline>سبک فونت خط زیر</FontStyleUnderline>
    <Link>ارتباط</Link>
    <Lock>قفل</Lock>
    <MakeHorizontalSpacingEqual>فضای افقی را برابر کن</MakeHorizontalSpacingEqual>
    <MakeSameHeight>ارتباط را برابر کن با {0}</MakeSameHeight>
    <MakeSameSize>اندازه را برابر کن با {0}</MakeSameSize>
    <MakeSameWidth>عرض را برابر کن با {0}</MakeSameWidth>
    <MakeVerticalSpacingEqual>فاصله های عمودی را برابر کن</MakeVerticalSpacingEqual>
    <MoveBackward>حرکت به عقب</MoveBackward>
    <MoveForward>حرکت به جلو</MoveForward>
    <Order>نظم</Order>
    <SendToBack>بفرست به عقب</SendToBack>
    <Size>سایز</Size>
    <StyleDesigner>طراح سبک</StyleDesigner>
    <Styles>لیست سبک ها</Styles>
    <TextBrush>قلم متن</TextBrush>
    <ToolbarFormatting>قالب بندی</ToolbarFormatting>
    <ToolbarLayout>طرح بندی</ToolbarLayout>
    <ToolbarStandard>استاندارد</ToolbarStandard>
    <ToolbarStyle>سبک</ToolbarStyle>
    <ToolbarTools>ابزارها</ToolbarTools>
  </Toolbars>
  <Toolbox>
    <Create>ایجاد مولفه ها</Create>
    <Hand>دست</Hand>
    <Select>انتخاب</Select>
    <Style>سبک کپی</Style>
    <TextEditor>ویرایشگر متن</TextEditor>
    <title>جعبه ابزار</title>
  </Toolbox>
  <Wizards>
    <BlankReport>گزارش خالی</BlankReport>
    <ButtonBack>&lt; &amp;پشتی</ButtonBack>
    <ButtonCancel>حذف</ButtonCancel>
    <ButtonFinish>&amp;پایان</ButtonFinish>
    <ButtonNext>&amp;بعدی &gt;</ButtonNext>
    <ColumnsOrder>نظم ستون ها</ColumnsOrder>
    <Custom>سنتی</Custom>
    <DataRelation>رابطه</DataRelation>
    <DataSource>منبع داده</DataSource>
    <DataSources>منابع داده</DataSources>
    <Filters>فیلترها</Filters>
    <FromReportTemplate>از الگوی گرازش</FromReportTemplate>
    <groupCreateNewReport>ایجاد گزارش جدید</groupCreateNewReport>
    <Groups>گروه ها</Groups>
    <groupTemplates>الگوها</groupTemplates>
    <groupWizards>جادوها</groupWizards>
    <infoColumnsOrder>.ترکیب ستون ها در نظم لازم </infoColumnsOrder>
    <infoDataSource>.انتخاب یک منبه داده از موجودی</infoDataSource>
    <infoDataSources>انتخاب منبع داده ار موجودی</infoDataSources>
    <infoFilters>فیلتر داده از گزارش</infoFilters>
    <infoGroups>.ستون هایی را که برای گروه بندی لازم است انتخاب کنید.</infoGroups>
    <infoLabelSettings>تنظیم تنظیمات برچسب ها</infoLabelSettings>
    <infoLayout>تعیین طرح بندی گزارش.</infoLayout>
    <infoRelation>Select one Data Relation from available.</infoRelation>
    <infoSelectColumns>ستون های را که می خواهید اطلاعاتش را ببینید انتخاب کنید.</infoSelectColumns>
    <infoSort>.گردآوری مرتب سازی داده.شما می توانید مرتب کنید فورا در چند ستون</infoSort>
    <infoTotals>اضافه کردن اطلاعات خلاصه به گزارش</infoTotals>
    <LabelDirection>:جهت</LabelDirection>
    <LabelHeight>ارتفاع:</LabelHeight>
    <LabelHorizontalGap>فضای خالی:</LabelHorizontalGap>
    <LabelLabelType>نوع برچسب:</LabelLabelType>
    <LabelLeftMargin>:حاشیه چپ</LabelLeftMargin>
    <LabelNumberOfColumns>تعداد ستون ها:</LabelNumberOfColumns>
    <LabelNumberOfRows>تعداد ستون ها:</LabelNumberOfRows>
    <LabelPageHeight>:ارتفاع صفحه</LabelPageHeight>
    <LabelPageWidth>عرض صفحه:</LabelPageWidth>
    <LabelReport>برچسب گزارش</LabelReport>
    <LabelSettings>تنظیمات برچسب</LabelSettings>
    <LabelSize>:سایز</LabelSize>
    <LabelTopMargin>:حاشیه بالا</LabelTopMargin>
    <LabelVerticalGap>:فضای عمودی</LabelVerticalGap>
    <LabelWidth>:عرض</LabelWidth>
    <Layout>طرح بندی</Layout>
    <MarkAll>همه &amp;مشخص کردن</MarkAll>
    <MasterDetailReport>گزارش کل به جزء</MasterDetailReport>
    <NoFunction>[هیچ]</NoFunction>
    <OpenExistingReport>گزارش موجودی باز</OpenExistingReport>
    <Preview>پیش نمایش</Preview>
    <Reset>پاک کردن</Reset>
    <SelectColumns>انتخاب ستون ها</SelectColumns>
    <Sort>مرتب سازی</Sort>
    <StandardReport>گرازش استاندارد</StandardReport>
    <title>گزارش جدید</title>
    <Totals>جمع ها</Totals>
    <UsingReportWizard>جادوی استفاده از گزارش</UsingReportWizard>
  </Wizards>
  <Zoom>
    <EmptyValue>مقدار پوچ</EmptyValue>
    <MultiplePages>چند صفحه</MultiplePages>
    <OnePage>یک صفحه</OnePage>
    <PageHeight>ارتفاع صفحه</PageHeight>
    <PageWidth>عرض صفحه</PageWidth>
    <TwoPages>2 صفحه</TwoPages>
    <ZoomTo100>زوم به 100 درصد</ZoomTo100>
  </Zoom>
</Localization>`;


    }
}